import React, { useEffect, useRef, useState } from "react";
import HorseLeasingSection from "./services/shared/components/HorseLeasingSection";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import {
    FetchCreateOrEditExportHorsethunk,
    FetchGetCovCerByHorseIdthunk,
    FetchGetServiceDefinitionByIdthunk,
    FetchGetServicesRequestByIdthunk,
    FetchGetShippingAgentsthunk,
    FetchApproveRejectExportHorsethunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
    resetGetServicesRequestByIdData,
    resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import dayjs from "dayjs";
import EahsForm from "../components/EahsForm";
import { FetchStudBookCountriesthunk } from "../Redux/StudBook/StudBookAction";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { base64ToBlob } from "../helper/base64ToBlob";
import AsyncSelect from "react-select/async";
import axiosInstance from "../axios/axios";
import { FetchOwnerHorsesDropDownthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import { isLessThanUndefinedYearOld } from "../helper/isLessThanUndefinedYearOld";
import axios from "../axios/axios";
import { Link } from "react-router-dom";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown, eformFormButton } from "../common/cssclasses";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import ApproveAndPayBtn from "../components/servicesButtons/ApproveAndPayBtn";
import { FetchCountriesthunk, FetchHorseColorsthunk } from "../Redux/LookUp/LookUpAction";
import { toast, ToastContainer } from "react-toastify";
import { formatDate } from "../helper/formatDate";

export default function ExportHorse() {
    //env
    const UMBRACOURL = process.env.REACT_APP_UMBRACO;
    // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
    const BaseURL = process.env.REACT_APP_BASE_URL;

    //selector
    const { studBookCountries, currentLanguage } = useSelector((state) => state.studBookSlice);
    const { countriesData, horseColorsData } = useSelector(
        (state) => state.lookUpSlice
    );
    const {
        toasterMessageServicesRequests,
        servicesRequestsLoading,
        getServicesRequestByIdData,
        getServiceDefinitionByIdData,
        exportHorseData,
        getShippingAgentsData,
        covCerByHorseIdData,
    } = useSelector((state) => state.servicesRequestsSlice);

    const { ownerHorsesDropDownData } = useSelector(
        (state) => state.ownerProfileSlice
    );

    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

    const dispatch = useDispatch();

    const { translate } = useTranslate();

    const navigate = useNavigate();

    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    const serviceId = searchParams.has("serviceId")
        ? searchParams.get("serviceId")
        : null;

    const id = searchParams.has("id") ? searchParams.get("id") : null;

    const action = searchParams.has("action") ? searchParams.get("action") : null;
    const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

    const isOwnerTransfer = searchParams.has("isOwnerTransfer") ? searchParams.get("isOwnerTransfer") : null;
    const isApproveHorseActionParam = searchParams.has("isApproveHorseAction") ? searchParams.has("isApproveHorseAction") === "true" : false;

    //state
    const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
        email: userProfile?.email,
        isShippingAgent: userProfile?.isShippingAgent,
    });

    const [formModel, setFormModel] = useState({
        id: "",
        exportHorseId: "",
        eventName: "",
        comment: "",
        referenceNumber: "",
        requestsType: "",
        paymentStatus: "",

        isOwnerTransfer: isOwnerTransfer === "true",
        isApproveHorseAction: isApproveHorseActionParam,

        exportType: "PERMANENT",

        exportDate: null,
        returnDate: null,

        exportTo: "",
        exportToDrop: {
            label: translate("web.chooseCountry", "Choose Country"),
            value: null,
        },

        horse: "",
        horseDrop: {
            label: translate("web.horse", "Horse"),
            value: null,
        },

        birthDate: "",
        color: "",
        sex: "",
        owner: "",

        isSheFoal: null,

        horseType: "Registered",
        //Unregistered horse
        horseNameEnUnReg: "",
        horseNameArUnReg: "",
        sexUnReg: "",
        sexUnRegDrop: {
            label: translate("web.sex", "Sex"),
            value: null,
        },
        damEnUnReg: "",
        damArUnReg: "",
        sireEnUnReg: "",
        sireArUnReg: "",
        breederNameEnUnReg: "",
        breederNameArUnReg: "",
        regoNoUnReg: "",
        colorUnReg: "",
        colorUnRegDrop: {
            label: translate("web.color", "Color"),
            value: null,
        },
        originUnReg: "",
        originUnRegDrop: {
            label: translate("web.chooseOrigin", "Choose Origin"),
            value: null,
        },
        horseCountryUnReg: "",
        horseCountryUnRegDrop: {
            label: translate("web.horseCountry", "Horse Country"),
            value: null,
        },
        birthDateUnReg: null,

        covCerId: "",
        covCerNo: "",
        stallion: "",
        coveringDate: "",
        otherOwner: false,

        buyer: "",
        buyerDrop: {
            label: translate("web.buyer", "Buyer"),
            value: "",
        },

        buyerName: "",

        receivingCountry: "",
        receivingCountryDrop: {
            label: translate("web.chooseCountry", "Choose Country"),
            value: null,
        },

        receivingCity: "",
        receivingCityDrop: {
            label: translate("web.chooseCity", "Choose City"),
            value: null,
        },

        receivingArea: "",
        email: "",
        phone: "",
        idNumber: "",

        shippingAgent: "",
        shippingAgentDrop: {
            label: currentLanguage === "en" ? translate("web.shippingAgent", "Shipping Agent") : "وكالة الشحن",
            value: null,
        },

        registerHorse: false,


        isCollectSemen: "No",
        numberOfDoses: 0,

        ownerComment: "",
        HorseOwnerComment: "",

        //isAddCovCer: true,

        filePathHorsePassport: "",
        fileTypeHorsePassport: "",
        fileNameHorsePassport: "",
        documentBase64HorsePassport: "",
        horsePassportAttachmentFile: null,

        filePathOwnerPassport: "",
        fileTypeOwnerPassport: "",
        fileNameOwnerPassport: "",
        fileUrlOwnerPassport: "",
        ownerPassportAttachmentFile: null,
        term1: false,
        ownerNameExport: profile?.label,
        emailExport: profile?.email,
        otherOwnerExport: false,
        registrationOfficeId: "",
        registrationOfficeIdDrop: {
            label: translate("web.chooseRegistrationOffice", "Choose Registration Office"),
            value: null,
        },
        isLeasing: false,
        leaseStartDate: null,
        leaseEndDate: null,
        canParticipateInBeautyChampionships: false,
        canCoverAndRegisterFoals: false,
        canRegisterFoalsForOtherOwners: false,
        canImportAndExport: false
    });
    const [registrationOfficeList, setRegistrationOfficeList] = useState([]);
    const [errorRegistrationOfficeId, setErrorRegistrationOfficeId] = useState(false);
    const registrationOfficeRef = useRef(null);
    const [nationalityOptions, setNationalityOptions] = useState(
        [formModel.receivingCountryDrop]
    )

    const [citiesList, setCitiesList] = useState([]);

    async function getNationalityList() {
        try {
            const nationalityList = await axios.get('/nationality')
            const formattedData = await nationalityList.data.result.map((item) => ({
                text: item.name,
                value: item.id,
            }));
            setNationalityOptions(formattedData)
        } catch (error) {
        }
    }

    async function getCitiesListbyID(id) {
        try {
            const citiesList = await axios.get(`/lookup/getcitybycountryid?id=${id}`)
            const formattedData = await citiesList.data.result.map((item) => ({
                text: item.name,
                value: item.id,
            }));
            setCitiesList(formattedData)
        } catch (error) {
            window.alert('error in region list')
        }
    }

    async function getRegistrationOfficeList(id, currentRegOfficeId = null) {
        try {
            const res = await axios.get(`/lookup/GetRegistrationOfficeCountries?id=${id}`)
            const formattedData = res.data.map((item) => ({
                label: item.text,
                value: item.value,
                details: item
            }));
            setRegistrationOfficeList(formattedData);

            // Auto select logic
            if (currentRegOfficeId) {
                const selectedItem = formattedData.find(item => item.value === currentRegOfficeId);
                if (selectedItem) {
                    setFormModel(prev => ({
                        ...prev,
                        registrationOfficeId: selectedItem.value,
                        registrationOfficeIdDrop: selectedItem
                    }));
                }
            } else {
                const defaultItem = formattedData.find(item => item.details.selected === true);
                if (defaultItem) {
                    setFormModel(prev => ({
                        ...prev,
                        registrationOfficeId: defaultItem.value,
                        registrationOfficeIdDrop: defaultItem
                    }));
                }
            }
        } catch (error) {
            console.error('error in registration office list', error);
        }
    }

    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const [inputValue, setInputValue] = useState("");
    const [inputBuyerValue, setInputBuyerValue] = useState("");
    const [timeoutId, setTimeoutId] = useState(0);
    const [timeoutBuyerId, setTimeoutBuyerId] = useState(0);
    const [errorExportDate, setErrorExportDate] = useState(false);
    const [errorIsSheFoaled, setErrorIsSheFoaled] = useState(false);
    const [errorReturnDate, setErrorReturnDate] = useState(false);
    const [errorExportTo, setErrorExportTo] = useState(false);
    const [errorHorse, setErrorHorse] = useState(false);
    const [errorCoveringCertificateNo, setErrorCoveringCertificateNo] = useState(false);
    const [errorStallionId, setErrorStallionId] = useState(false);

    const [errorHorseNameEnUnReg, setErrorHorseNameEnUnReg] = useState(false);
    const [errorHorseNameArUnReg, setErrorHorseNameArUnReg] = useState(false);
    const [errorSexUnReg, setErrorSexUnReg] = useState(false);
    const [errorDamEnUnReg, setErrorDamEnUnReg] = useState(false);
    const [errorDamArUnReg, setErrorDamArUnReg] = useState(false);
    const [errorSireEnUnReg, setErrorSireEnUnReg] = useState(false);
    const [errorSireArUnReg, setErrorSireArUnReg] = useState(false);
    const [errorBreederNameEnUnReg, setErrorBreederNameEnUnReg] = useState(false);
    const [errorBreederNameArUnReg, setErrorBreederNameArUnReg] = useState(false);
    const [errorRegoNoUnReg, setErrorRegoNoUnReg] = useState(false);
    const [errorColorUnReg, setErrorColorUnReg] = useState(false);
    const [errorOriginUnReg, setErrorOriginUnReg] = useState(false);
    const [errorHorseCountryUnReg, setErrorHorseCountryUnReg] = useState(false);
    const [errorBirthDateUnReg, setErrorBirthDateUnReg] = useState(false);
    const [microChipUnReg, setErrorMicroChipUnReg] = useState(false);

    const [errorCoveringDate, setErrorCoveringDate] = useState(false);
    const [errorBuyer, setErrorBuyer] = useState(false);
    const [errorReceivingCountry, setErrorReceivingCountry] = useState(false);
    const [errorReceivingCity, setErrorReceivingCity] = useState(false);
    const [errorReceivingArea, setErrorReceivingArea] = useState(false);
    const [errorShippingAgent, setErrorShippingAgent] = useState(false);
    const [errorHorsePassport, setErrorHorsePassport] = useState(false);
    const [errorOwnerPassport, setErrorOwnerPassport] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorEmailExport, setErrorEmailExport] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [errorIdNumber, setErrorIdNumber] = useState(false);
    const [errorAddress, setErrorAddress] = useState(false);
    const [errorBuyerName, setErrorBuyerName] = useState(false);
    const [errorNumberOfSemenDoses, setErrorNumberOfSemenDoses] = useState(false);
    const [errorOwnerName, setErrorOwnerName] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [isAgentPhoneNumberValid, setIsAgentPhoneNumberValid] = useState(true);
    const [errorAgentMobile, setErrorAgentMobile] = useState(false);
    const [
        residencePermitAttachmentFile,
        setResidencePermitAttachmentFile,
    ] = useState([]);
    const [errorPassportNo, setErrorPassportNo] = useState(false);
    const [errorResidencePermit, setErrorResidencePermit] = useState(false);
    const [errorHorseOwnerComment, setErrorHorseOwnerComment] = useState(false);
    const [
        leasingContractAttachmentFile,
        setLeasingContractAttachmentFile,
    ] = useState([]);
    const [errorLeasingContract, setErrorLeasingContract] = useState(false);
    const [errorLeaseStartDate, setErrorLeaseStartDate] = useState(false);
    const [errorLeaseEndDate, setErrorLeaseEndDate] = useState(false);
    const [errorLeasePermissions, setErrorLeasePermissions] = useState(false);


    //use ref
    const exportDateRef = useRef(null);
    const isSheFoaledRef = useRef(null);
    const returnDateRef = useRef(null);
    const leasingContractRef = useRef(null);
    const leaseStartDateRef = useRef(null);
    const leaseEndDateRef = useRef(null);
    const leasePermissionsRef = useRef(null);
    const exportToRef = useRef(null);
    const horseRef = useRef(null);
    const horseNameEnUnRegRef = useRef(null);
    const horseNameArUnRegRef = useRef(null);
    const sexUnRegRef = useRef(null);
    const damEnUnRegRef = useRef(null);
    const damArUnRegRef = useRef(null);
    const sireEnUnRegRef = useRef(null);
    const sireArUnRegRef = useRef(null);
    const breederNameEnUnRegRef = useRef(null);
    const breederNameArUnRegRef = useRef(null);
    const regoNoUnRegRef = useRef(null);
    const colorUnRegRef = useRef(null);
    const originUnRegRef = useRef(null);
    const horseCountryUnRegRef = useRef(null);
    const birthDateUnRegRef = useRef(null);
    const microChipUnRegRef = useRef(null);
    const coveringCertificateNoRef = useRef(null);

    const buyerRef = useRef(null);
    const receivingCountryRef = useRef(null);
    const receivingCityRef = useRef(null);
    const receivingAreaRef = useRef(null);

    const ownerPassportRef = useRef(null);
    const horsePassportRef = useRef(null);
    const phoneRef = useRef(null);
    const idNumberRef = useRef(null);
    const emailRef = useRef(null);
    const shippingAgentRef = useRef(null);
    const AddressRef = useRef(null);
    const buyerNameRef = useRef(null);
    const numberOfSemenDosesRef = useRef(null);
    const emailRefExport = useRef(null);
    const ownerNameRef = useRef(null);
    const mobileRef = useRef(null);
    const passportNoRef = useRef(null);
    const residencePermitRef = useRef(null);
    const agentMobileRef = useRef(null);


    const [
        horsePassportAttachmentFile,
        setHorsePassportAttachmentFile,
    ] = useState([]);

    const [
        ownerPassportAttachmentFile,
        setOwnerPassportAttachmentFile,
    ] = useState([]);


    const _isOnlinePayment = useRef("");

    const [checkedItems, setCheckedItems] = useState({});

    const subAccountId = localStorage.getItem("currentSubAccountId");

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 50,
            minHeight: 50,
        }),
    };

    const nowDate = new Date();
    const oneYearAgo = new Date(nowDate);  // Copy the current date
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    oneYearAgo.setDate(oneYearAgo.getDate() - 10);

    //function   
    const handleFormChange = (e, input) => {
        if (input === "exportTo") {
            getCitiesListbyID(e.value);
            getRegistrationOfficeList(e.value);

            setFormModel({
                ...formModel,
                exportTo: e.value,
                exportToDrop: e,
                receivingCity: "",
                receivingCityDrop: {
                    label: translate("web.chooseCity", "Choose City"),
                    value: null,
                },
                registrationOfficeId: "",
                registrationOfficeIdDrop: {
                    label: translate("web.chooseRegistrationOffice", "Choose Registration Office"),
                    value: null,
                },
            });
        }
        else if (input === "horseType") {
            setFormModel({
                ...formModel,
                horseType: e.target.value,

                horse: "",
                horseDrop: {
                    label: translate("web.horse", "Horse"),
                    value: null,
                },
                birthDate: "",
                sex: "",
                color: "",
                owner: "",

                isSheFoal: false,

                covCerId: "",
                covCerNo: "",
                stallion: "",
                coveringDate: "",

                isCollectSemen: "No",
                numberOfDoses: 0,

                horseNameEnUnReg: "",
                horseNameArUnReg: "",
                sexUnReg: "",
                damEnUnReg: "",
                damArUnReg: "",
                sireEnUnReg: "",
                sireArUnReg: "",
                breederNameEnUnReg: "",
                breederNameArUnReg: "",
                regoNoUnReg: "",
                colorUnReg: "",
                colorUnRegDrop: {
                    label: translate("web.color", "Color"),
                    value: null,
                },
                originUnReg: "",
                originUnRegDrop: {
                    label: translate("web.chooseOrigin", "Choose Origin"),
                    value: null,
                },
                horseCountryUnReg: "",
                horseCountryUnRegDrop: {
                    label: translate("web.horseCountry", "Horse Country"),
                    value: null,
                },
                birthDateUnReg: null,
            });
        }
        else if (!!input && input === "horse") {
            if (!e || !e.value) {
                setFormModel({
                    ...formModel,
                    horse: "",
                    horseDrop: {
                        label: translate("web.horse", "Horse"),
                        value: null,
                    },
                    birthDate: "",
                    sex: "",
                    color: "",
                    owner: "",
                    covCerId: "",
                    covCerNo: "",
                    stallion: "",
                    coveringDate: "",
                });

                return;
            }

            let horse = e.details ? [e.details] : ownerHorsesDropDownData.filter((item) => item.id == e.value);
            const selectedHorse = horse?.[0] ?? {};

            const ownerName =
                selectedHorse?.horseOwnerName
                || selectedHorse?.ownerName
                || selectedHorse?.owner
                || selectedHorse?.ownerFullName
                || "";

            const ownerDisplay = ownerName;

            if (e.value !== "" && selectedHorse?.gender === "Mare") {
                let params = {
                    horseId: e.value,
                    ownerId: getUserID(),
                }

                dispatch(FetchGetCovCerByHorseIdthunk(params));
            }

            setFormModel({
                ...formModel,
                horse: e.value,
                horseDrop: e,
                birthDate: selectedHorse?.birthDateObject ?? selectedHorse?.birthDate ?? "",
                sex: selectedHorse?.gender ?? "",
                color: selectedHorse?.color ?? "",
                owner: ownerDisplay,
                covCerId: "",
                covCerNo: "",
                stallion: "",
                coveringDate: "",
            });
        }

        else if (input === "isSheFoal") {
            setFormModel({
                ...formModel,
                isSheFoal: e.target.value === "true",
            });
        }

        else if (input === "otherOwner") {
            setFormModel({
                ...formModel,
                otherOwner: e.target.checked,
                otherOwnerExport: e.target.checked ? false : formModel.otherOwnerExport,
                buyer: "",
                buyerDrop: {
                    label: translate("web.buyer", "Buyer"),
                    value: "",
                },

                buyerName: "",

                receivingCountry: "",
                receivingCountryDrop: {
                    label: translate("web.chooseCountry", "Choose Country"),
                    value: null,
                },

                // receivingCity: "",
                // receivingCityDrop: {
                //     label: translate("web.chooseCity", "Choose City"),
                //     value: null,
                // },

                receivingArea: "",
                email: "",
                phone: "",
                idNumber: "",
                filePathOwnerPassport: "",
                fileTypeOwnerPassport: "",
                fileNameOwnerPassport: "",
                fileUrlOwnerPassport: "",
            });

            setOwnerPassportAttachmentFile([]);
            setInputBuyerValue("");
            setIsPhoneNumberValid(true);
            setErrorBuyer(false);
            setErrorBuyerName(false);
            setErrorPhone(false);
            setErrorIdNumber(false);
            setErrorEmail(false);
            setErrorOwnerPassport(false);
        }
        else if (input === "otherOwnerExport") {
            if (e.target.checked == true) {
                setFormModel({
                    ...formModel,
                    otherOwnerExport: e.target.checked,
                    otherOwner: false,
                    ownerNameExport: "",
                    emailExport: "",
                    
                    // Clear buyer info just in case
                    buyer: "",
                    buyerDrop: { label: translate("web.buyer", "Buyer"), value: "" },
                    buyerName: "",
                    receivingCountry: "",
                    receivingCountryDrop: { label: translate("web.chooseCountry", "Choose Country"), value: null },
                    email: "",
                    phone: "",
                    idNumber: "",
                });
            } else {
                setFormModel({
                    ...formModel,
                    otherOwnerExport: e.target.checked,
                });
            }

            setIsPhoneNumberValid(true);
        }

        else if (input === "term1") {
            setFormModel({
                ...formModel,
                term1: e.target.checked,
            });
        }

        else if (input === "isLeasing") {
            setFormModel({
                ...formModel,
                isLeasing: e.target.checked,
                leaseStartDate: null,
                leaseEndDate: null,
                canParticipateInBeautyChampionships: false,
                canCoverAndRegisterFoals: false,
                canRegisterFoalsForOtherOwners: false,
                canImportAndExport: false,
                otherOwner: false,
                buyer: "",
                buyerDrop: {
                    label: translate("web.buyer", "Buyer"),
                    value: "",
                },
                buyerName: "",
                phone: "",
                idNumber: "",
                email: "",
                filePathOwnerPassport: "",
                fileTypeOwnerPassport: "",
                fileNameOwnerPassport: "",
                fileUrlOwnerPassport: "",
            });
            setLeasingContractAttachmentFile([]);
            setOwnerPassportAttachmentFile([]);
            setInputBuyerValue("");
            setIsPhoneNumberValid(true);
            setErrorLeaseStartDate(false);
            setErrorLeaseEndDate(false);
            setErrorLeasingContract(false);
            setErrorLeasePermissions(false);
            setErrorBuyer(false);
            setErrorBuyerName(false);
            setErrorPhone(false);
            setErrorIdNumber(false);
            setErrorEmail(false);
            setErrorOwnerPassport(false);
        }

        else if (["canParticipateInBeautyChampionships", "canCoverAndRegisterFoals", "canRegisterFoalsForOtherOwners", "canImportAndExport"].includes(input)) {
            setFormModel({
                ...formModel,
                [input]: e.target.checked,
                ...(input === "canCoverAndRegisterFoals" && !e.target.checked ? { canRegisterFoalsForOtherOwners: false } : {}),
            });
        }
        else if (["leaseStartDate", "leaseEndDate"].includes(input)) {
            setFormModel({
                ...formModel,
                [input]: e.target.value,
            });
        }

        else if (input === "buyer") {
            if (e?.value != null && e?.value != undefined) {
                setFormModel({
                    ...formModel,
                    buyerDrop: e,
                    buyer: e.value,

                    email: e.details?.email || "",
                    phone: e.details?.phone || "",
                    idNumber: e.details?.idNumber || "",
                    receivingArea: e.details?.areaName || "",
                });
                setErrorBuyer(false);
            } else {
                setFormModel({
                    ...formModel,
                    buyerDrop: null,
                    buyer: "",
                    email: "",
                    phone: "",
                    idNumber: "",
                    receivingArea: "",
                });
            }
        }

        else if (input === "receivingCountry") {
            //getCitiesListbyID(e.value);

            setFormModel({
                ...formModel,
                receivingCountry: e.value,
                receivingCountryDrop: e,
                // receivingCity: "",
                // receivingCityDrop: {
                //     label: translate("web.chooseCity", "Choose City"),
                //     value: null,
                // },
            });
        }

        else if (input === "receivingCity") {
            setFormModel({
                ...formModel,
                receivingCity: e.value,
                receivingCityDrop: e,
            });
        }

        else if (input === "phone") {
            setFormModel({
                ...formModel,
                phone: e?.target?.value ?? e,
            });
        }

        else if (input === "shippingAgent") {
            setFormModel({
                ...formModel,
                shippingAgent: e.value,
                shippingAgentDrop: e,
            });
        }
        else if (input === "registrationOfficeId") {
            setFormModel({
                ...formModel,
                registrationOfficeId: e.value,
                registrationOfficeIdDrop: e,
            });
        }
        else if (!!input && input === "isCollectSemen") {
            setFormModel({
                ...formModel,
                isCollectSemen: e.target.value,
                numberOfDoses: e.target.value === "No" ? 0 : formModel.numberOfDoses
            });
        }
        else if (!!input && input === "horseNameEnUnReg") {
            const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    horseNameEnUnReg: e.target.value.toUpperCase(),
                });
            }
        }
        else if (input === "sexUnReg") {
            setFormModel({
                ...formModel,
                sexUnReg: e.value,
                sexUnRegDrop: e,
            });
        }
        else if (!!input && input === "damEnUnReg") {
            const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    damEnUnReg: e.target.value.toUpperCase(),
                });
            }
        }
        else if (!!input && input === "sireEnUnReg") {
            const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    sireEnUnReg: e.target.value.toUpperCase(),
                });
            }
        }
        else if (!!input && input === "breederNameEnUnReg") {
            const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    breederNameEnUnReg: e.target.value.toUpperCase(),
                });
            }
        }
        else if (!!input && input === "colorUnReg") {
            setFormModel({
                ...formModel,
                colorUnReg: e.value,
                colorUnRegDrop: e,
            });
        }
        else if (!!input && input === "originUnReg") {
            setFormModel({
                ...formModel,
                originUnReg: e.value,
                originUnRegDrop: e,
            });
        }
        else if (!!input && input === "horseCountryUnReg") {
            setFormModel({
                ...formModel,
                horseCountryUnReg: e.value,
                horseCountryUnRegDrop: e,
            });
        }
        else if (!!input && input === "birthDateUnReg") {
            setFormModel({
                ...formModel,
                birthDateUnReg: e.target.value,
            });
        } else if (input === "mobile") {
            setFormModel({
                ...formModel,
                mobile: e,
            });
        }
        else if (input === "agentMobile") {
            setFormModel({
                ...formModel,
                agentMobile: e,
            });
        }
        else {
            if (e.target.name === "HorseOwnerComment") {
                setErrorHorseOwnerComment(false);
            }
            setFormModel({
                ...formModel,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleUploadHorsePassportChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    horsePassportAttachmentFile: e.target.files[0],
                });

                setHorsePassportAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };
    const handleUploadResidencePermitChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    residencePermitAttachmentFile: e.target.files[0],
                });

                setResidencePermitAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };
    
    const handleUploadLeasingContractChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    leasingContractAttachmentFile: e.target.files[0],
                });

                setLeasingContractAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };

    const handleUploadOwnerPassportChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    ownerPassportAttachmentFile: e.target.files[0],
                });

                setOwnerPassportAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };



    const validInputs = () => {
        let valid = true;

        if (
            formModel.exportDate === null
        ) {
            setErrorExportDate(true);
            valid = false;

            exportDateRef?.current?.focus();
            return;
        }
        else {
            setErrorExportDate(false);
        }
        if (
            formModel.sex === "Mare" && formModel.isSheFoal == null
        ) {
            setErrorIsSheFoaled(true);
            valid = false;

            isSheFoaledRef?.current?.focus();
            return;
        }
        else {
            setErrorIsSheFoaled(false);
        }

        if (
            formModel.returnDate === null && formModel.exportType?.toLowerCase() === "TEMPORARY".toLowerCase()
        ) {
            setErrorReturnDate(true);
            valid = false;

            returnDateRef?.current?.focus();
            return;
        }
        else {
            setErrorReturnDate(false);
        }

        if (
            formModel.exportTo === ""
        ) {
            setErrorExportTo(true);
            valid = false;

            exportToRef?.current?.focus();
            return;
        }
        else {
            setErrorExportTo(false);
        }

        if (
            formModel.registrationOfficeId === "" || formModel.registrationOfficeId === null
        ) {
            setErrorRegistrationOfficeId(true);
            valid = false;

            registrationOfficeRef?.current?.focus();
            return;
        }
        else {
            setErrorRegistrationOfficeId(false);
        }

        if (
            formModel.receivingCity === ""
        ) {
            setErrorReceivingCity(true);
            valid = false;

            receivingCityRef?.current?.focus();
            return;
        }
        else {
            setErrorReceivingCity(false);
        }



        if (
            formModel.horseType?.toLowerCase() === "Registered".toLowerCase() &&
            formModel.horse === ""
        ) {
            setErrorHorse(true);
            valid = false;

            horseRef?.current?.focus();
            return;
        }
        else {
            setErrorHorse(false);
        }
        if (formModel.horseType.toLowerCase() === "Unregistered".toLowerCase()) {
            if (
                formModel.horseNameEnUnReg === ""
            ) {
                setErrorHorseNameEnUnReg(true);
                valid = false;

                horseNameEnUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorHorseNameEnUnReg(false);
            }
            if (
                formModel.horseNameArUnReg === ""
            ) {
                setErrorHorseNameArUnReg(true);
                valid = false;

                horseNameArUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorHorseNameArUnReg(false);
            }
            if (
                formModel.sexUnReg === ""
            ) {
                setErrorSexUnReg(true);
                valid = false;

                sexUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorSexUnReg(false);
            }
            if (
                formModel.damEnUnReg === ""
            ) {
                setErrorDamEnUnReg(true);
                valid = false;

                damEnUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorDamEnUnReg(false);
            }
            if (
                formModel.damArUnReg === ""
            ) {
                setErrorDamArUnReg(true);
                valid = false;

                damArUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorDamArUnReg(false);
            }
            if (
                formModel.sireEnUnReg === ""
            ) {
                setErrorSireEnUnReg(true);
                valid = false;

                sireEnUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorSireEnUnReg(false);
            }
            if (
                formModel.sireArUnReg === ""
            ) {
                setErrorSireArUnReg(true);
                valid = false;

                sireArUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorSireArUnReg(false);
            }
            if (
                formModel.breederNameEnUnReg === ""
            ) {
                setErrorBreederNameEnUnReg(true);
                valid = false;

                breederNameEnUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorBreederNameEnUnReg(false);
            }
            if (
                formModel.breederNameArUnReg === ""
            ) {
                setErrorBreederNameArUnReg(true);
                valid = false;

                breederNameArUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorBreederNameArUnReg(false);
            }
            if (
                formModel.regoNoUnReg === ""
            ) {
                setErrorRegoNoUnReg(true);
                valid = false;

                regoNoUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorRegoNoUnReg(false);
            }
            if (
                formModel.colorUnReg === ""
            ) {
                setErrorColorUnReg(true);
                valid = false;

                colorUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorColorUnReg(false);
            }
            if (
                formModel.originUnReg === ""
            ) {
                setErrorOriginUnReg(true);
                valid = false;

                originUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorOriginUnReg(false);
            }
            if (
                formModel.horseCountryUnReg === ""
            ) {
                setErrorHorseCountryUnReg(true);
                valid = false;

                horseCountryUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorHorseCountryUnReg(false);
            }
            if (
                formModel.birthDateUnReg === null
            ) {
                setErrorBirthDateUnReg(true);
                valid = false;

                birthDateUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorBirthDateUnReg(false);
            }
            if (
                !formModel?.microshipUnReg
            ) {
                setErrorMicroChipUnReg(true);
                valid = false;

                microChipUnRegRef?.current?.focus();
                return;
            }
            else {
                setErrorMicroChipUnReg(false);
            }
            if (formModel.otherOwnerExport == true) {
                if (
                    !formModel?.ownerNameExport
                ) {
                    setErrorOwnerName(true);
                    valid = false;

                    ownerNameRef?.current?.focus();
                    return;
                }
                else {
                    setErrorOwnerName(false);
                }
                if (
                    !formModel?.emailExport
                ) {
                    setErrorEmailExport(true);
                    valid = false;

                    emailRefExport?.current?.focus();
                    return;
                }
                else {
                    setErrorEmailExport(false);
                }
                if (!formModel?.mobile) {
                    setErrorMobile(true);
                    valid = false;
                    mobileRef?.current?.focus();
                    return;
                }
                else {
                    setErrorMobile(false);
                }
                if (!formModel?.agentMobile) {
                    setErrorAgentMobile(true);
                    valid = false;
                    agentMobileRef?.current?.focus();
                    return;
                }
                else {
                    setErrorAgentMobile(false);
                }
                if (!formModel?.passportNo) {
                    setErrorPassportNo(true);
                    valid = false;
                    passportNoRef?.current?.focus();
                    return;
                }
                else {
                    setErrorPassportNo(false);
                }
                if (!formModel?.passportNo) {
                    setErrorPassportNo(true);
                    valid = false;
                    passportNoRef?.current?.focus();
                    return;
                }
                else {
                    setErrorPassportNo(false);
                }
                if (residencePermitAttachmentFile.length === 0
                    && formModel.fileUrlResidencePermit === "") {
                    setErrorResidencePermit(true);
                    valid = false;
                    residencePermitRef?.current?.focus();
                    return;
                }
                else {
                    setErrorResidencePermit(false);
                }
            }
            if (
                horsePassportAttachmentFile?.length === 0
                && !formModel?.horsePassportFile
            ) {
                setErrorHorsePassport(true);
                valid = false;
            }
            else {
                setErrorHorsePassport(false);
            }

        }

        if (!!formModel.sex && formModel.sex.toLowerCase() === "Stallion".toLowerCase() && !!formModel.birthDate && !isLessThanUndefinedYearOld(new Date(formModel.birthDate), 2) && formModel.isCollectSemen?.toLowerCase() === "Yes"?.toLowerCase() && (formModel.numberOfDoses === "" || Number(formModel.numberOfDoses) < 1) && formModel.isOwnerTransfer) {
            setErrorNumberOfSemenDoses(true);
            valid = false;

            numberOfSemenDosesRef?.current?.focus();
            return;
        }
        else {
            setErrorNumberOfSemenDoses(false);
        }

        if (
            formModel.sex?.toLowerCase() === "Mare".toLowerCase() && formModel.isSheFoal
        ) {
            if (
                formModel.covCerId === ""
            ) {
                setErrorCoveringCertificateNo(true);
                valid = false;

                coveringCertificateNoRef?.current?.focus();

                toast.error(
                    translate("web.noValidCovCer", "No Valid Cov Cer")
                );

                return;
            }
            else {
                setErrorCoveringCertificateNo(false);
            }
        }

        if (
            !formModel.isOwnerTransfer || (formModel.isOwnerTransfer && formModel.otherOwner) || (formModel.isLeasing && formModel.otherOwner)
        ) {
            // if (
            //     formModel.receivingCountry === ""
            // ) {
            //     setErrorReceivingCountry(true);
            //     valid = false;

            //     receivingCountryRef?.current?.focus();
            //     return;
            // }
            // else {
            //     setErrorReceivingCountry(false);
            // }        

            // if (
            //     formModel.receivingArea === ""
            // ) {
            //     setErrorReceivingArea(true);
            //     valid = false;

            //     receivingAreaRef?.current?.focus();
            //     return;
            // }
            // else {
            //     setErrorReceivingArea(false);
            // }

            if (
                formModel.phone === ""
            ) {
                setErrorPhone(true);
                valid = false;

                phoneRef?.current?.focus();
                return;
            }
            else {
                setErrorPhone(false);
            }

            if (
                formModel.otherOwner && formModel.idNumber === ""
            ) {
                setErrorIdNumber(true);
                valid = false;

                idNumberRef?.current?.focus();
                return;
            }
            else {
                setErrorIdNumber(false);
            }

            if (
                formModel.email === ""
            ) {
                setErrorEmail(true);
                valid = false;

                emailRef?.current?.focus();
                return;
            }
            else {
                setErrorEmail(false);
            }
        }

        if (!formModel.otherOwner && (formModel.isOwnerTransfer || formModel.isLeasing)) {
            if (formModel.buyer === "") {
                setErrorBuyer(true);
                valid = false;

                buyerRef?.current?.focus();
                return;
            }
            else {
                setErrorBuyer(false);
            }
        }

        if (
            (formModel.isOwnerTransfer || formModel.isLeasing) && formModel.otherOwner
        ) {
            if (
                formModel.buyerName === ""
            ) {
                setErrorBuyerName(true);
                valid = false;

                buyerNameRef?.current?.focus();
                return;
            }
            else {
                setErrorBuyerName(false);
            }
        }

        if (
            formModel.shippingAgent === ""
        ) {
            setErrorShippingAgent(true);
            valid = false;

            shippingAgentRef?.current?.focus();
            return;
        }
        else {
            setErrorShippingAgent(false);
        }

        if (
            ownerPassportAttachmentFile.length === 0
            && formModel.fileUrlOwnerPassport === ""
            && (formModel.isOwnerTransfer || formModel.isLeasing)
            && formModel.otherOwner
        ) {
            setErrorOwnerPassport(true);
            valid = false;
        }
        else {
            setErrorOwnerPassport(false);
        }

        //term
        if (Object.values(checkedItems).length > 0) {  // Optional safe check
            const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

            if (action == null && (!allTermsChecked || (!formModel.term1 && formModel.exportType === "TEMPORARY"))) {
                toast.error(
                    translate("web.pleaseCheckAllTerms", "Please Check All Terms")
                );
                valid = false;
            }
        }

        if (!formModel.isOwnerTransfer && formModel.isLeasing) {
            if (!formModel.leaseStartDate) {
                setErrorLeaseStartDate(true);
                valid = false;
                leaseStartDateRef?.current?.focus();
                return;
            } else {
                setErrorLeaseStartDate(false);
            }

            if (!formModel.leaseEndDate) {
                setErrorLeaseEndDate(true);
                valid = false;
                leaseEndDateRef?.current?.focus();
                return;
            } else {
                setErrorLeaseEndDate(false);
            }

            if (leasingContractAttachmentFile.length === 0) {
                setErrorLeasingContract(true);
                valid = false;
                leasingContractRef?.current?.focus();
                return;
            } else {
                setErrorLeasingContract(false);
            }

            if (
                !formModel.canParticipateInBeautyChampionships &&
                !formModel.canCoverAndRegisterFoals &&
                !formModel.canRegisterFoalsForOtherOwners &&
                !formModel.canImportAndExport
            ) {
                setErrorLeasePermissions(true);
                valid = false;
                leasePermissionsRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return valid;
            } else {
                setErrorLeasePermissions(false);
            }
        } else {
            setErrorLeaseStartDate(false);
            setErrorLeaseEndDate(false);
            setErrorLeasingContract(false);
            setErrorLeasePermissions(false);
        }

        return valid;
    }

    const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
        debugger;
        if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack" && formModel.eventName !== "HorseOwnerRejected") {
            const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}`;

            const encodeURI = encodeURIComponent(returnUrl);

            window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=${!formModel.isOwnerTransfer ? 25 : 26}&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
        }
        else {
            if (
                validInputs()
            ) {
                _isOnlinePayment.current = isOnlinePayment;

                let params = {
                    id: id == null ? '' : id,
                    ownerId: getUserID(),
                    status: status,
                    ownerComment: formModel.ownerComment,
                    exportHorseId: formModel.exportHorseId,

                    exportType: formModel.exportType,
                    exportDate: dayjs(formModel.exportDate).format("DD/MM/YYYY"),
                    returnDate: formModel.returnDate == null ? '' : dayjs(formModel.returnDate).format("DD/MM/YYYY"),

                    exportTo: formModel.exportTo,
                    receivingCity: formModel.receivingCity,
                    address: formModel?.address,

                    receivingCountry: formModel.exportTo,
                    receivingArea: formModel.receivingArea,

                    horse: formModel.horse,

                    horseType: formModel.horseType,
                    horseNameEnUnReg: formModel.horseNameEnUnReg,
                    horseNameArUnReg: formModel.horseNameArUnReg,
                    sexUnReg: formModel.sexUnReg,
                    damEnUnReg: formModel.damEnUnReg,
                    damArUnReg: formModel.damArUnReg,
                    sireEnUnReg: formModel.sireEnUnReg,
                    sireArUnReg: formModel.sireArUnReg,
                    breederNameEnUnReg: formModel.breederNameEnUnReg,
                    breederNameArUnReg: formModel.breederNameArUnReg,
                    regoNoUnReg: formModel.regoNoUnReg,
                    colorUnReg: formModel.colorUnReg,
                    originUnReg: formModel.originUnReg,
                    horseCountryUnReg: formModel.horseCountryUnReg,
                    birthDateUnReg: formModel.birthDateUnReg == null ? '' : dayjs(formModel.birthDateUnReg).format("DD/MM/YYYY"),

                    isCollectSemen: formModel.isCollectSemen === "Yes",
                    numberOfDoses: formModel.numberOfDoses,

                    isSheFoal: formModel.isSheFoal,
                    covCerId: formModel.covCerId,
                    otherOwner: formModel.otherOwner,
                    buyer: formModel.buyer,
                    buyerName: formModel.buyerName,
                    phone: formModel.phone,
                    idNumber: formModel.idNumber,
                    email: formModel.email,

                    shippingAgentId: formModel.shippingAgent,
                    RegistrationOfficeId: formModel.registrationOfficeId,

                    isOwnerTransfer: formModel.isOwnerTransfer,

                    ownerPassportFile: formModel.ownerPassportAttachmentFile,
                    buttonAction: buttonAction,
                    microshipUnReg: formModel?.microshipUnReg,
                    horsePassportFile: formModel?.horsePassportAttachmentFile,
                    ownerType: formModel?.otherOwnerExport == true ? "UnRegisterOwner" : "CurrentOwner",
                    ownerFullName: formModel?.ownerNameExport,
                    ownerEmail: formModel?.emailExport,
                    ownerPhoneNo: formModel?.mobile,
                    authAgentPhoneNo: formModel?.agentMobile,
                    passportNo: formModel?.passportNo,
                    ownerPassportOrEmiratesIdCopyFile: residencePermitAttachmentFile?.at(-1)?.file,
                    isLeasing: !formModel.isOwnerTransfer ? formModel.isLeasing : false,
                    leaseStartDate: formModel.leaseStartDate != null ? dayjs(formModel.leaseStartDate).format("DD/MM/YYYY") : "",
                    leaseEndDate: formModel.leaseEndDate != null ? dayjs(formModel.leaseEndDate).format("DD/MM/YYYY") : "",
                    canParticipateInBeautyChampionships: formModel.canParticipateInBeautyChampionships,
                    canCoverAndRegisterFoals: formModel.canCoverAndRegisterFoals,
                    canRegisterFoalsForOtherOwners: (
                        formModel.sex?.toLowerCase?.() === "mare" ||
                        formModel.sexUnReg === 1 ||
                        formModel.sexUnReg === "1" ||
                        formModel.sexUnRegDrop?.value === 1 ||
                        formModel.sexUnRegDrop?.value === "1" ||
                        formModel.sexUnRegDrop?.label?.toLowerCase?.() === "mare"
                    ) ? formModel.canRegisterFoalsForOtherOwners : false,
                    canImportAndExport: formModel.canImportAndExport,
                    leasingContractFile: leasingContractAttachmentFile?.at(-1)?.file,
                };
                dispatch(FetchCreateOrEditExportHorsethunk(params));
            }
            else {
                toast.error(
                    translate("web.completeTheRequiredData", "Complete The Required Data")
                );
            }
        }
    };

    const handelSelectedAccountChange = async (element) => {
        let params = {
            ownerId: element.value,
            skip: 0,
            take: 1000,
            langauge: currentLanguage,
            horseTypeFilter: "1",
            searchValue: "",
            sortBy: "-1",
            serviceDefinitionId: serviceId,
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        setProfile(element);

        setFormModel({
            ...formModel,
            horse: "",
            horseDrop: {
                label: translate("web.horse", "Horse"),
                value: null,
            },
            birthDate: "",
            sex: "",
            color: "",
            isCollectSemen: "No",
            numberOfDoses: 0,
            isSheFoal: false,
            covCerId: "",
            covCerNo: "",
            stallion: "",
            coveringDate: "",
            ownerNameExport: element?.label,
            emailExport: element?.email
        });
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        setCheckedItems((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    function CheckIfAgentHasPermission() {
        const AgentHasPermission = userProfile.subAccounts
            .filter((x) => x.value == subAccountId)[0]
            .ownersPermissionsList.some(
                (x) =>
                    ((x.permissionName === "ExportHorse" && !formModel.isOwnerTransfer) || (x.permissionName === "ExportOwnershipTransferHorse" && formModel.isOwnerTransfer)) || x.permissionName === "All"
            );

        return AgentHasPermission;
    }

    // const getUserID = () => {
    //     const userID =
    //         !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;

    //     return userID;
    // };
    const getUserID = () => {
        let userID =
            !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
        if ((action == null || action === "edit") == false) {
            userID = subAccountId;
        }
        return userID;
    };

    const getSelectedAccountName = () => {
        const selectAccount = userProfile.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };

    const dismissAll = () => toast.dismiss();

    const handelDisabledButton = () => {
        if (
            action === "view"
            || (action === "approve" && formModel.eventName !== "SentBack" && formModel.eventName !== "HorseOwnerRejected")
            || formModel.isApproveHorseAction === true
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    const handelDisabledInputs = () => {
        if (
            action === "view"
            || (action === "approve" && (formModel.eventName === "SentBack" || formModel.eventName === "HorseOwnerRejected"))
            || formModel.isApproveHorseAction === true
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    const handleApproveReject = (statusText) => {
        // statusText will be "Approve" or "Reject"
        if (statusText === "Reject" && (!formModel.HorseOwnerComment || formModel.HorseOwnerComment.trim() === "")) {
            setErrorHorseOwnerComment(true);
            toast.error(translate("web.completeTheRequiredData", "Complete The Required Data"));
            return;
        }

        setErrorHorseOwnerComment(false);

        let params = {
            id: id,
            status: statusText,
            HorseOwnerComment: formModel.HorseOwnerComment
        };

        dispatch(FetchApproveRejectExportHorsethunk(params));
    };

    const handelDisabledOwnerInputs = () => {
        if (
            action === "view"
            || (action != null && formModel.isOwnerTransfer && formModel.otherOwner)
            || formModel.isApproveHorseAction === true
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    const isShippingAgentEnabled = profile?.isShippingAgent === true;

    // async search
    const promiseBuyerOptions = (searchKeyword) =>
        new Promise((resolve) => {
            if (timeoutBuyerId > 0) {
                clearTimeout(timeoutBuyerId);
            }

            const id = setTimeout(async () => {
                const response = await axiosInstance.post(
                    "/StudBook/FilterOwnersOrUsers",
                    {
                        langauge: localStorage.getItem("eahsLang") ?? "en",
                        ownerId: searchKeyword,
                        skip: 0,
                        take: 10000,
                        tableType: "user",
                    }
                );

                const data = await response.data.ownersList;

                const options = data.map((item) => ({
                    label: item.ownerId + " - " + item.name,
                    value: item.id,
                    details: item,
                }));
                resolve(options);
            }, 1000);

            setTimeoutBuyerId(id);
        });

    const promiseRegisteredHorseOptions = (searchKeyword) =>
        new Promise((resolve) => {
            if (timeoutId > 0) {
                clearTimeout(timeoutId);
            }

            const id = setTimeout(async () => {
                const response = await axiosInstance.post(
                    "/servicesrequests/searchregisterednotexportedhorses",
                    {
                        searchValue: searchKeyword,
                        subAccountId: getUserID(),
                    }
                );

                const data = response.data?.result || response.data?.horsesList || response.data || [];
                
                const options = Array.isArray(data) ? data.map((item) => ({
                    label: (item.registerNumber || "") + " - " + item.name,
                    value: item.id,
                    details: item,
                })) : [];
                resolve(options);
            }, 1000);

            setTimeoutId(id);
        });

    //Effect
    useEffect(() => {
        if (id != null) {
            let params = {
                language: currentLanguage,
                id: id,
                ownerId: ownerId,
            };

            dispatch(FetchGetServicesRequestByIdthunk(params));
        }

        return () => {
            dispatch(resetGetServicesRequestByIdData());
        };
    }, []);

    useEffect(() => {
        if (!!userProfile && userProfile?.haveProfileSignture != true) {
            toast.error(
                translate(
                    "web.completeOwnerProfileData",
                    "Please complete the personal data of the profile."
                )
            );

            setTimeout(() => {
                navigate("/profile");
            }, 3000);
        }

        if (!!userProfile && userProfile?.accountType === "Agent") {
            if (userProfile.id == subAccountId) {
                navigate("/403-Not-Authrized");
            }

            if (!CheckIfAgentHasPermission()) {
                navigate("/403-Not-Authrized");
            }
        }

        dispatch(FetchCountriesthunk({ langauge: currentLanguage }));
        dispatch(FetchHorseColorsthunk({ langauge: currentLanguage }));

        let params = {
            ownerId: getUserID(),
            skip: 0,
            take: 1000,
            langauge: currentLanguage,
            horseTypeFilter: "1",
            searchValue: "",
            sortBy: "-1",
            serviceDefinitionId: serviceId,
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        let subOwnerProfilesParams = {
            id: getUserID(),
            langauge: currentLanguage,
        };
        dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

        dispatch(FetchStudBookCountriesthunk(currentLanguage));

        dispatch(FetchGetShippingAgentsthunk());

        dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));

        getNationalityList();

    }, [currentLanguage]);

    useEffect(() => {
        if (getServicesRequestByIdData != null &&
            Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
        ) {
            setResidencePermitAttachmentFile([{
                filePath: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.filePath : "",
                fileType: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileType : "",
                fileName: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileName : "",
                name: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileName : "",
                fileUrl: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileUrl : "",
                file: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileUrl : "",
            }])
            setFormModel({
                ...formModel,
                eventName: getServicesRequestByIdData.eventName,
                comment: getServicesRequestByIdData.comment,
                requestsType: getServicesRequestByIdData.requestsType,
                paymentStatus: getServicesRequestByIdData.paymentStatus,
                referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
                // new
                otherOwnerExport: getServicesRequestByIdData.exportHorseDto?.ownerType?.toLowerCase() == "UnRegisterOwner".toLowerCase(),
                ownerNameExport: getServicesRequestByIdData.exportHorseDto?.ownerFullName,
                emailExport: getServicesRequestByIdData.exportHorseDto?.ownerEmail,
                mobile: getServicesRequestByIdData.exportHorseDto?.ownerPhoneNo,
                agentMobile: getServicesRequestByIdData.exportHorseDto?.authAgentPhoneNo,
                passportNo: getServicesRequestByIdData.exportHorseDto?.passportNo,
                isApproveHorseAction: isApproveHorseActionParam || getServicesRequestByIdData.exportHorseDto?.isApproveHorseAction === true,
                filePathResidencePermit: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.filePath : "",
                fileTypeResidencePermit: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileType : "",
                fileNameResidencePermit: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileName : "",
                fileUrlResidencePermit: getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile != null ? getServicesRequestByIdData?.exportHorseDto?.ownerPassportFile?.fileUrl : "",
                // finish New
                exportHorseId: getServicesRequestByIdData.exportHorseDto.exportHorseId,
                exportType: getServicesRequestByIdData.exportHorseDto.exportType,
                exportDate: dayjs(getServicesRequestByIdData.exportHorseDto.exportDateTime).format("YYYY-MM-DD"),
                returnDate: getServicesRequestByIdData.exportHorseDto.returnDateTime != null ? dayjs(getServicesRequestByIdData.exportHorseDto.returnDateTime).format("YYYY-MM-DD") : null,
                exportTo: getServicesRequestByIdData.exportHorseDto.exportTo,
                exportToDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.exportToName,
                    value: getServicesRequestByIdData.exportHorseDto.exportTo,
                },
                registrationOfficeId: getServicesRequestByIdData.exportHorseDto.registrationOfficeId != null ? getServicesRequestByIdData.exportHorseDto.registrationOfficeId : "",
                registrationOfficeIdDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.registrationOfficeName != null ? getServicesRequestByIdData.exportHorseDto.registrationOfficeName : translate("web.chooseRegistrationOffice", "Choose Registration Office"),
                    value: getServicesRequestByIdData.exportHorseDto.registrationOfficeId != null ? getServicesRequestByIdData.exportHorseDto.registrationOfficeId : null,
                },
                horse: getServicesRequestByIdData.exportHorseDto.horse != null ? getServicesRequestByIdData.exportHorseDto.horse : "",
                horseDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.horseName,
                    value: getServicesRequestByIdData.exportHorseDto.horse,
                },
                horsePassportFile: getServicesRequestByIdData.exportHorseDto.horsePassportFile,
                birthDate: getServicesRequestByIdData.exportHorseDto?.birthDateObject,
                sex: getServicesRequestByIdData.exportHorseDto.sex,
                color: getServicesRequestByIdData.exportHorseDto.color,
                owner: getServicesRequestByIdData.exportHorseDto?.horseOwnerName ?? getServicesRequestByIdData.exportHorseDto?.ownerName ?? "",
                isCollectSemen: getServicesRequestByIdData.exportHorseDto.isCollectSemen == true ? "Yes" : "No",
                numberOfDoses: getServicesRequestByIdData.exportHorseDto.numberOfDoses != null ? getServicesRequestByIdData.exportHorseDto.numberOfDoses : 0,

                horseType: getServicesRequestByIdData.exportHorseDto.horseType,
                horseNameEnUnReg: getServicesRequestByIdData.exportHorseDto.horseNameEnUnReg != null ? getServicesRequestByIdData.exportHorseDto.horseNameEnUnReg : "",
                horseNameArUnReg: getServicesRequestByIdData.exportHorseDto.horseNameArUnReg != null ? getServicesRequestByIdData.exportHorseDto.horseNameArUnReg : "",
                microshipUnReg: getServicesRequestByIdData?.exportHorseDto?.microshipUnReg,

                sexUnReg: getServicesRequestByIdData.exportHorseDto.sexUnReg != null ? getServicesRequestByIdData.exportHorseDto.sexUnReg : "",
                sexUnRegDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.sexUnReg == 1 ? translate("web.mare", "Mare") : (getServicesRequestByIdData.exportHorseDto.sexUnReg == 2 ? translate("web.stallion", "Stallion") : (getServicesRequestByIdData.exportHorseDto.sexUnReg == 3 ? translate("web.gelding", "Gelding") : translate("web.sex", "Sex"))),
                    value: getServicesRequestByIdData.exportHorseDto.sexUnReg,
                },
                damEnUnReg: getServicesRequestByIdData.exportHorseDto.damEnUnReg != null ? getServicesRequestByIdData.exportHorseDto.damEnUnReg : "",
                damArUnReg: getServicesRequestByIdData.exportHorseDto.damArUnReg != null ? getServicesRequestByIdData.exportHorseDto.damArUnReg : "",
                sireEnUnReg: getServicesRequestByIdData.exportHorseDto.sireEnUnReg != null ? getServicesRequestByIdData.exportHorseDto.sireEnUnReg : "",
                sireArUnReg: getServicesRequestByIdData.exportHorseDto.sireArUnReg != null ? getServicesRequestByIdData.exportHorseDto.sireArUnReg : "",
                breederNameEnUnReg: getServicesRequestByIdData.exportHorseDto.breederNameEnUnReg != null ? getServicesRequestByIdData.exportHorseDto.breederNameEnUnReg : "",
                breederNameArUnReg: getServicesRequestByIdData.exportHorseDto.breederNameArUnReg != null ? getServicesRequestByIdData.exportHorseDto.breederNameArUnReg : "",
                regoNoUnReg: getServicesRequestByIdData.exportHorseDto.regoNoUnReg != null ? getServicesRequestByIdData.exportHorseDto.regoNoUnReg : "",

                colorUnReg: getServicesRequestByIdData.exportHorseDto.colorUnReg != null ? getServicesRequestByIdData.exportHorseDto.colorUnReg : "",
                colorUnRegDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.colorNameUnReg,
                    value: getServicesRequestByIdData.exportHorseDto.colorUnReg,
                },
                originUnReg: getServicesRequestByIdData.exportHorseDto.originUnReg != null ? getServicesRequestByIdData.exportHorseDto.originUnReg : "",
                originUnRegDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.originNameUnReg,
                    value: getServicesRequestByIdData.exportHorseDto.originUnReg,
                },
                horseCountryUnReg: getServicesRequestByIdData.exportHorseDto.horseCountryUnReg != null ? getServicesRequestByIdData.exportHorseDto.horseCountryUnReg : "",
                horseCountryUnRegDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.horseCountryNameUnReg,
                    value: getServicesRequestByIdData.exportHorseDto.horseCountryUnReg,
                },
                birthDateUnReg: getServicesRequestByIdData.exportHorseDto.birthDateUnReg != null ? dayjs(getServicesRequestByIdData.exportHorseDto.birthDateUnReg).format("YYYY-MM-DD") : null,

                isSheFoal: getServicesRequestByIdData.exportHorseDto.isSheFoal,
                covCerId: getServicesRequestByIdData.exportHorseDto.coveringCertificateId != null ? getServicesRequestByIdData.exportHorseDto.coveringCertificateId : "",
                covCerNo: getServicesRequestByIdData.exportHorseDto.coveringCertificateNo != null ? getServicesRequestByIdData.exportHorseDto.coveringCertificateNo : "",
                stallion: getServicesRequestByIdData.exportHorseDto.stallionName,

                coveringDate: getServicesRequestByIdData.exportHorseDto.coveringDate != null ? dayjs(getServicesRequestByIdData.exportHorseDto.coveringDate).format("YYYY-MM-DD") : "",

                otherOwner: false, // Force to false when editing because the buyer becomes a registered owner upon submission
                buyerName: getServicesRequestByIdData.exportHorseDto.buyerName != null ? getServicesRequestByIdData.exportHorseDto.buyerName : "",
                buyer: getServicesRequestByIdData.exportHorseDto.buyerId != null ? getServicesRequestByIdData.exportHorseDto.buyerId : "",
                buyerDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.buyerName,
                    value: getServicesRequestByIdData.exportHorseDto.buyerId,
                },
                address: getServicesRequestByIdData.exportHorseDto.address != null ? getServicesRequestByIdData?.exportHorseDto?.address : "",
                receivingCountry: getServicesRequestByIdData.exportHorseDto.country != null ? getServicesRequestByIdData.exportHorseDto.country : "",
                receivingCountryDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.countryName,
                    value: getServicesRequestByIdData.exportHorseDto.country,
                },
                receivingCity: getServicesRequestByIdData.exportHorseDto.city != null ? getServicesRequestByIdData.exportHorseDto.city : "",
                receivingCityDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.cityName,
                    value: getServicesRequestByIdData.exportHorseDto.city,
                },
                receivingArea: getServicesRequestByIdData.exportHorseDto.area != null ? getServicesRequestByIdData.exportHorseDto.area : "",
                phone: getServicesRequestByIdData.exportHorseDto.mobile != null ? getServicesRequestByIdData.exportHorseDto.mobile : "",
                idNumber: getServicesRequestByIdData.exportHorseDto.idNumber != null ? getServicesRequestByIdData.exportHorseDto.idNumber : "",
                email: getServicesRequestByIdData.exportHorseDto.email != null ? getServicesRequestByIdData.exportHorseDto.email : "",

                shippingAgent: getServicesRequestByIdData.exportHorseDto.shippingAgentId,
                shippingAgentDrop: {
                    label: getServicesRequestByIdData.exportHorseDto.shippingAgentName,
                    value: getServicesRequestByIdData.exportHorseDto.shippingAgentId,
                },

                ownerComment: getServicesRequestByIdData.exportHorseDto.ownerComment != null ? getServicesRequestByIdData.exportHorseDto.ownerComment : "",
                isOwnerTransfer: getServicesRequestByIdData.exportHorseDto.isOwnerTransfer,

                isLeasing: getServicesRequestByIdData.exportHorseDto.isLeasing ?? false,
                leaseStartDate: getServicesRequestByIdData.exportHorseDto.leaseStartDate != null ? dayjs(getServicesRequestByIdData.exportHorseDto.leaseStartDate).format("YYYY-MM-DD") : null,
                leaseEndDate: getServicesRequestByIdData.exportHorseDto.leaseEndDate != null ? dayjs(getServicesRequestByIdData.exportHorseDto.leaseEndDate).format("YYYY-MM-DD") : null,
                canParticipateInBeautyChampionships: getServicesRequestByIdData.exportHorseDto.canParticipateInBeautyChampionships ?? false,
                canCoverAndRegisterFoals: getServicesRequestByIdData.exportHorseDto.canCoverAndRegisterFoals ?? false,
                canRegisterFoalsForOtherOwners: getServicesRequestByIdData.exportHorseDto.canRegisterFoalsForOtherOwners ?? false,
                canImportAndExport: getServicesRequestByIdData.exportHorseDto.canImportAndExport ?? false,

                filePathOwnerPassport: getServicesRequestByIdData.exportHorseDto.ownerPassportFile != null ? getServicesRequestByIdData.exportHorseDto.ownerPassportFile.filePath : "",
                fileTypeOwnerPassport: getServicesRequestByIdData.exportHorseDto.ownerPassportFile != null ? getServicesRequestByIdData.exportHorseDto.ownerPassportFile.fileType : "",
                fileNameOwnerPassport: getServicesRequestByIdData.exportHorseDto.ownerPassportFile != null ? getServicesRequestByIdData.exportHorseDto.ownerPassportFile.fileName : "",
                fileUrlOwnerPassport: getServicesRequestByIdData.exportHorseDto.ownerPassportFile != null ? getServicesRequestByIdData.exportHorseDto.ownerPassportFile.fileUrl : "",
                term1: true,
            });

            // leasing contract file
            if (getServicesRequestByIdData.exportHorseDto.leasingContractFile != null) {
                setLeasingContractAttachmentFile([{
                    file: getServicesRequestByIdData.exportHorseDto.leasingContractFile.fileUrl,
                    name: getServicesRequestByIdData.exportHorseDto.leasingContractFile.fileName,
                }]);
            }

            //another owner
            if (
                getServicesRequestByIdData.exportHorseDto.ownerId !==
                getServicesRequestByIdData.exportHorseDto.createdBy &&
                subOwnerProfilesByIdData.length > 0 &&
                getServicesRequestByIdData.requestsType !== "BackOffice" &&
                getServicesRequestByIdData.exportHorseDto.ownerType !== "UnRegisterOwner"
            ) {
                //update profile                
                setProfile({
                    label:
                        subOwnerProfilesByIdData.filter(
                            (item) =>
                                item.value ==
                                getServicesRequestByIdData.exportHorseDto.ownerId
                        )[0].registerNo +
                        " - " +
                        subOwnerProfilesByIdData.filter(
                            (item) =>
                                item.value ==
                                getServicesRequestByIdData.exportHorseDto.ownerId
                        )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
                    value: subOwnerProfilesByIdData.filter(
                        (item) =>
                            item.value == getServicesRequestByIdData.exportHorseDto.ownerId
                    )[0].value,
                    email: subOwnerProfilesByIdData.filter(
                        (item) =>
                            item.value == getServicesRequestByIdData.exportHorseDto.ownerId
                    )[0]?.email,
                });
            }
        }
    }, [
        getServicesRequestByIdData,
    ]);

    useEffect(() => {
        if (covCerByHorseIdData != null && Object.keys(covCerByHorseIdData).length > 0) {
            setFormModel({
                ...formModel,
                covCerId: covCerByHorseIdData.id,
                covCerNo: covCerByHorseIdData.referenceNumber,
                stallion: covCerByHorseIdData.stallionName,
                coveringDate: dayjs(covCerByHorseIdData.CoveringDate).format("DD/MM/YYYY"),
                // stallionId: covCerByHorseIdData.stallionId,
                // stallionIdDrop: {
                //     label: covCerByHorseIdData.stallionName,
                //     value: covCerByHorseIdData.stallionId,
                // },
                //isAddCovCer: false,
            })
        }
    }, [covCerByHorseIdData]);

    useEffect(() => {
        if (
            toasterMessageServicesRequests != null &&
            toasterMessageServicesRequests === "save"
        ) {
            if (_isOnlinePayment.current !== "") {
                toast.success(
                    translate(
                        "web.yourRequestHasSubmittedSuccessfully",
                        "Your Request Has Submitted Successfully"
                    )
                );
            } else {
                toast.success(
                    translate("web.dataSavedSuccessfully", "Data Saved Successfully")
                );
            }

            dispatch(resetToasterMessageServicesRequests());

            setTimeout(() => {
                if (_isOnlinePayment.current !== "") {
                    const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}`;

                    const encodeURI = encodeURIComponent(returnUrl);

                    window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${exportHorseData.id}&paymentType=${!formModel.isOwnerTransfer ? 25 : 26}&userId=${localStorage.getItem(
                        "EAHSUserID"
                    )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
                } else {
                    navigate(`/profile?activeTab=${"e_services"}`);
                }
            }, 1000);
        }

        //error
        else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
            if (toasterMessageServicesRequests !== "errorServiceDetails") {

                setTimeout(() => {
                    toast.error(
                        translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
                    );
                }, 1000);

                dispatch(resetToasterMessageServicesRequests());
            }

            else if (toasterMessageServicesRequests === "errorServiceDetails") {
                toast.error(
                    translate("web.createServiceRequestFailed", "Service Request Failed")
                );

                dispatch(resetToasterMessageServicesRequests());

                setTimeout(() => {
                    navigate(`/profile?activeTab=${"e_services"}`);
                }, 1000);
            }
        }
    }, [toasterMessageServicesRequests]);

    useEffect(() => {
        if (getServiceDefinitionByIdData?.termsList) {
            const initialState = {};
            getServiceDefinitionByIdData.termsList.forEach((_, index) => {
                initialState[`option${index + 1}`] = false;
            });

            setCheckedItems(initialState);
        }
    }, [getServiceDefinitionByIdData?.termsList]);

    //consoles
    console.log("formModel", formModel);
    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            <div className="container-fluid container-fluid-padding">

                {/* loading div */}
                <div
                    className={`page-overlay text-center ${servicesRequestsLoading
                        ? "classdisplay"
                        : "classnotdisplay"
                        }`}
                >
                    <div className="loaderDiv">
                        <Loader />
                    </div>
                </div>

                {/* content page */}
                <div className={serviceRequestHeadContainer}>
                    <h2 className={serviceRequestTitle}>
                        {currentLanguage === "en"
                            ? getServiceDefinitionByIdData.nameEn
                            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
                    </h2>
                    {/* Selected Account */}
                    {subOwnerProfilesByIdData.length > 0 &&
                        (action == null || action === "edit") && (
                            <div className={userDropDown}>
                                {!!userProfile && userProfile?.accountType !== "Agent" ? (
                                    <>
                                        <NetaqInput
                                            label={translate("web.selectedAccount", "Selected Account")}
                                            name="selectAccount"
                                            type="select"
                                            listSelect={[
                                                ...(!!subOwnerProfilesByIdData &&
                                                    !!subOwnerProfilesByIdData.length > 0 &&
                                                    subOwnerProfilesByIdData.map((a) => ({
                                                        label:
                                                            a?.registerNo +
                                                            " - " +
                                                            a[`text${currentLanguage == "en" ? "" : "Ar"}`],
                                                        text:
                                                            a?.registerNo +
                                                            " - " +
                                                            a[`text${currentLanguage == "en" ? "" : "Ar"}`],
                                                        value: a.value,
                                                        ...a
                                                    }))),
                                            ]} value={profile}
                                            placeholder={localStorage.getItem("EAHSUserFullName")}
                                            onChange={(e) => {
                                                handelSelectedAccountChange(e);
                                            }}
                                        />
                                    </>
                                ) : (
                                    getSelectedAccountName() != false &&

                                    <label className="capatalize_text">
                                        {getSelectedAccountName()?.registerNo +
                                            " - " +
                                            getSelectedAccountName()[
                                            `text${currentLanguage == "en" ? "" : "Ar"}`
                                            ]}
                                    </label>
                                )}
                            </div>
                        )}
                </div>
                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.exportDetails", "Export Details")}>
                    {!formModel.isOwnerTransfer && (
                        <div className="row mx-0">
                            <label>
                                {translate("web.exportType", "Exort Type")}
                            </label>
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    name={"exportType"}
                                    type={"radioServiceRequest"}
                                    value={"TEMPORARY"}
                                    label={`${translate("web.temporary", "Temporary")}-`}
                                    onChange={handleFormChange}
                                    checked={formModel.exportType === "TEMPORARY"}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    name={"exportType"}
                                    type={"radioServiceRequest"}
                                    value={"PERMANENT"}
                                    label={`${translate("web.permanent", "Permanent")}-`}
                                    onChange={handleFormChange}
                                    checked={formModel.exportType === "PERMANENT"}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                        </div>
                    )}

                    <div className={eformInput}>
                        <NetaqInput
                            htmlTags={
                                formModel.exportDate ?
                                    <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                        {
                                            dayjs(formModel.exportDate).format("DD/MM/YYYY")
                                        }
                                    </p> :
                                    <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                        DD/MM/YYYY
                                    </p>
                            }
                            name={"exportDate"}
                            type={"normalDateService"}
                            label={translate("web.exportDate", "Date Of Export")}
                            onChange={handleFormChange}
                            value={formModel.exportDate}
                            required={true}
                            minDate={dayjs().format("YYYY-MM-DD")}
                            disabled={handelDisabledButton()}
                            ref={exportDateRef}
                        />
                        {errorExportDate && (
                            <p style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </p>
                        )}
                    </div>
                    {formModel.exportType === "TEMPORARY" && (
                        <div className={eformInput}>
                            <NetaqInput
                                htmlTags={
                                    formModel.returnDate ?
                                        <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                            {
                                                dayjs(formModel.returnDate).format("DD/MM/YYYY")
                                            }
                                        </p> :
                                        <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                            DD/MM/YYYY
                                        </p>
                                }
                                name={"returnDate"}
                                type={"normalDateService"}
                                label={translate("web.returnDate", "Date Of Return")}
                                onChange={handleFormChange}
                                value={formModel.returnDate}
                                required={true}
                                minDate={dayjs(formModel.exportDate).format("YYYY-MM-DD")}
                                maxDate={dayjs(formModel.exportDate).add(3, "month").format("YYYY-MM-DD")}
                                disabled={handelDisabledButton()}
                                ref={returnDateRef}
                            />
                            {errorReturnDate && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>
                    )}
                    {/* To Do */}
                    <div className={eformInput}>
                        <label>
                            {translate("web.exportTo", "Export To")}
                            <i className="colorred"> *</i>
                        </label>
                        <Select
                            options={[
                                {
                                    label: translate("web.chooseCountry", "Choose Country"),
                                    value: null,
                                },
                                ...(!!studBookCountries &&
                                    studBookCountries.map((a) => ({
                                        label: a.text,
                                        value: a.value,
                                    }))),
                            ]}
                            value={formModel.exportToDrop}
                            onChange={(e) => handleFormChange(e, "exportTo")}
                            placeholder={translate("web.chooseCountry", "Choose Country")}
                            name={"exportTo"}
                            isSearchable
                            noOptionsMessage={() =>
                                translate("web.noOptions", "No Options")
                            }
                            autoFocus={true}
                            key={"exportTo"}
                            isDisabled={handelDisabledButton()}
                            ref={exportToRef}
                        />
                        {errorExportTo && (
                            <span style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </span>
                        )}
                    </div>

                    <div className={eformInput}>
                        <label>
                            {translate("web.exportRegistrationOffice", "Registration Office")}
                            <i className="colorred"> *</i>
                        </label>
                        <Select
                            options={registrationOfficeList}
                            value={formModel.registrationOfficeIdDrop}
                            onChange={(e) => handleFormChange(e, "registrationOfficeId")}
                            placeholder={translate("web.chooseRegistrationOffice", "Choose Registration Office")}
                            name={"registrationOfficeId"}
                            isSearchable
                            noOptionsMessage={() =>
                                translate("web.noOptions", "No Options")
                            }
                            key={"registrationOfficeId"}
                            isDisabled={handelDisabledButton()}
                            ref={registrationOfficeRef}
                        />
                        {errorRegistrationOfficeId && (
                            <span style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </span>
                        )}
                    </div>

                    <div className={eformInput}>
                        <NetaqInput
                            type={"select"}
                            label={translate("web.city", "City")}
                            placeholder={translate("web.chooseCity", "Choose city")}
                            name={"receivingCity"}
                            listSelect={citiesList}
                            value={formModel?.receivingCityDrop}
                            onChange={(e) => handleFormChange(e, "receivingCity")}
                            // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                            // disabled={(formModel.isOwnerTransfer && !formModel.otherOwner) || action === "view"}
                            disabled={handelDisabledButton()}
                            required={true}
                            ref={receivingCityRef}
                        />
                        {errorReceivingCity && (
                            <span style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </span>
                        )}
                    </div>

                    <div className={eformInput}>
                        <NetaqInput
                            label={translate("web.address", "Address")}
                            name={"address"}
                            type={"text"}
                            value={formModel.address}
                            onChange={handleFormChange}
                            required={false}
                            ref={AddressRef}
                            disabled={handelDisabledButton()}
                        />

                    </div>

                    {!formModel.isOwnerTransfer && !formModel.isLeasing && (
                        <>
                            {formModel.otherOwner ? <div className={eformInput}>
                                <NetaqInput
                                    type={'phone'}
                                    value={formModel.phone}
                                    label={translate("web.smsPhoneNo", "Mobile No")}
                                    name={'phone'}
                                    placeholder={'971xxxxxxxxx'}
                                    required={true}
                                    onChange={(e) => handleFormChange(e, "phone")}
                                    setIsPhoneNumberValid={setIsPhoneNumberValid}
                                    // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                    disabled={(formModel.isOwnerTransfer && !formModel.otherOwner) || action === "view"}
                                    ref={phoneRef}
                                />
                                {!isPhoneNumberValid &&
                                    <div className='text-danger'>
                                        {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                    </div>
                                }
                                {errorPhone && (
                                    <p style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </p>
                                )}
                            </div>
                                :
                                <>
                                    <div className={eformInput}>
                                        <NetaqInput
                                            type={'text'}
                                            value={formModel.phone}
                                            label={translate("web.smsPhoneNo", "Mobile No")}
                                            name={'phone'}
                                            onChange={(e) => {
                                                setFormModel({ ...formModel, phone: e.target.value })
                                            }}
                                            placeholder={'971xxxxxxxxx'}
                                            required={true}
                                            ref={phoneRef}
                                        />
                                        {errorPhone && (
                                            <p style={{ color: "red" }}>
                                                {translate("web.requiredField", "Required Field")}
                                            </p>
                                        )}
                                    </div>
                                </>
                            }
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.email", "Email")}
                                    name={"email"}
                                    type={"text"}
                                    required={true}
                                    // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                    disabled={(formModel.isOwnerTransfer && !formModel.otherOwner) || action === "view"}
                                    onChange={handleFormChange}
                                    value={formModel.email}
                                    ref={emailRef}
                                />
                                {errorEmail && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>

                        </>
                    )}
                </EahsForm>

                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseDetails", "Horse Details")}>
                    {!formModel.isOwnerTransfer && (
                        <div className={eformInput + " row mx-0"}>
                            <label>
                                {translate("web.horseType", "Horse Type")}
                            </label>
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    name={"horseType"}
                                    type={"radioServiceRequest"}
                                    value={"Registered"}
                                    label={`${translate("web.registered", "Registered")}-`}
                                    onChange={(e) => handleFormChange(e, "horseType")}
                                    checked={
                                        formModel.horseType === "Registered"
                                    }
                                    disabled={handelDisabledButton()}
                                />
                            </div>

                            <div className={eformCheckBox}>
                                <NetaqInput
                                    name={"horseType"}
                                    type={"radioServiceRequest"}
                                    value={"UnRegistered"}
                                    label={`${translate("web.unregistered", "Unregistered")}-`}
                                    onChange={(e) => handleFormChange(e, "horseType")}
                                    checked={
                                        formModel.horseType === "UnRegistered"
                                    }
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                        </div>
                    )}

                    {formModel.horseType === "Registered" && (
                        <>
                            <div className={eformInput}>
                                <label>
                                    {translate("web.horse", "Horse")}
                                    <i className="colorred"> *</i>
                                </label>
                                {isShippingAgentEnabled ? (
                                    <AsyncSelect
                                        isClearable
                                        loadOptions={promiseRegisteredHorseOptions}
                                        defaultOptions={false}
                                        onInputChange={(newValue) => setInputValue(newValue)}
                                        inputValue={inputValue}
                                        value={formModel.horseDrop}
                                        loadingMessage={() => translate("web.loading", "Loading")}
                                        onChange={(e) => handleFormChange(e, "horse")}
                                        placeholder={translate("web.typeToSearch", "Type To Search") + "..."}
                                        noOptionsMessage={() =>
                                            translate("web.noOptions", "No Options")
                                        }
                                        autoFocus={true}
                                        key={"horse-async"}
                                        isDisabled={handelDisabledButton()}
                                        ref={horseRef}
                                    />
                                ) : (
                                    <Select
                                        options={[
                                            {
                                                label: translate("web.horse", "Horse"),
                                                value: null,
                                            },
                                            ...(!!ownerHorsesDropDownData &&
                                                ownerHorsesDropDownData.map((a) => ({
                                                    label: a.registerNumber + " - " + a.name,
                                                    value: a.id,
                                                }))),
                                        ]}
                                        value={formModel.horseDrop}
                                        onChange={(e) => handleFormChange(e, "horse")}
                                        placeholder={translate("web.horse", "Horse")}
                                        name={"horse"}
                                        isSearchable
                                        noOptionsMessage={() =>
                                            translate("web.noOptions", "No Options")
                                        }
                                        autoFocus={true}
                                        key={"horse-select"}
                                        isDisabled={handelDisabledButton()}
                                        ref={horseRef}
                                    />
                                )}
                                {errorHorse && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>

                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.birthDate", "Birth Date")}
                                    name={"birthDate"}
                                    type={"renderDate"}
                                    value={formModel?.birthDate}
                                />
                            </div>

                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.sex", "Sex")}
                                    name={"sex"}
                                    type={"text"}
                                    value={translate(
                                        `web._${formModel.sex.toLowerCase()}`,
                                        formModel.sex
                                    )}
                                    disabled={true}
                                />
                            </div>

                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.color", "Color")}
                                    name={"color"}
                                    type={"text"}
                                    value={formModel.color}
                                    disabled={true}
                                />
                            </div>

                            {isShippingAgentEnabled && (
                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web.ownerName", "Owner Name")}
                                        name={"owner"}
                                        type={"text"}
                                        value={formModel.owner}
                                        disabled={true}
                                    />
                                </div>
                            )}
                        </>
                    )}
                    {formModel.horseType === "UnRegistered" && (
                        <>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.horse", "Horse") + " (EN)"}
                                    name={"horseNameEnUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.horseNameEnUnReg}
                                    onChange={(e) => handleFormChange(e, "horseNameEnUnReg")}
                                    disabled={handelDisabledButton()}
                                    ref={horseNameEnUnRegRef}
                                />
                                {errorHorseNameEnUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.horse", "Horse") + " (AR)"}
                                    name={"horseNameArUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.horseNameArUnReg}
                                    onChange={handleFormChange}
                                    disabled={handelDisabledButton()}
                                    ref={horseNameArUnRegRef}
                                />
                                {errorHorseNameArUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <label>
                                    {translate("web.sex", "Sex")}
                                    <i className="colorred"> *</i>
                                </label>
                                <Select
                                    options={[
                                        {
                                            label: translate("web.sex", "Sex"),
                                            value: null,
                                        },
                                        { value: 1, label: translate("web.mare", "Mare") },
                                        { value: 2, label: translate("web.stallion", "Stallion") },
                                        { value: 3, label: translate("web.gelding", "Gelding") }
                                    ]}
                                    value={formModel.sexUnRegDrop}
                                    onChange={(e) => handleFormChange(e, "sexUnReg")}
                                    placeholder={translate("web.sex", "Sex")}
                                    name={"sexUnReg"}
                                    isSearchable
                                    noOptionsMessage={() =>
                                        translate("web.noOptions", "No Options")
                                    }
                                    autoFocus={true}
                                    key={"sexUnReg"}
                                    isDisabled={handelDisabledButton()}
                                    ref={sexUnRegRef}
                                />
                                {errorSexUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.dam", "Dam") + " (EN)"}
                                    name={"damEnUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.damEnUnReg}
                                    onChange={(e) => handleFormChange(e, "damEnUnReg")}
                                    disabled={handelDisabledButton()}
                                    ref={damEnUnRegRef}
                                />
                                {errorDamEnUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.dam", "Dam") + " (AR)"}
                                    name={"damArUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.damArUnReg}
                                    onChange={handleFormChange}
                                    disabled={handelDisabledButton()}
                                    ref={damArUnRegRef}
                                />
                                {errorDamArUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.sire", "Sire") + " (EN)"}
                                    name={"sireEnUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.sireEnUnReg}
                                    onChange={(e) => handleFormChange(e, "sireEnUnReg")}
                                    disabled={handelDisabledButton()}
                                    ref={sireEnUnRegRef}
                                />
                                {errorSireEnUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.sire", "Sire") + " (AR)"}
                                    name={"sireArUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.sireArUnReg}
                                    onChange={handleFormChange}
                                    disabled={handelDisabledButton()}
                                    ref={sireArUnRegRef}
                                />
                                {errorSireArUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.breeder", "Breeder") + " (EN)"}
                                    name={"breederNameEnUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.breederNameEnUnReg}
                                    onChange={(e) => handleFormChange(e, "breederNameEnUnReg")}
                                    disabled={handelDisabledButton()}
                                    ref={breederNameEnUnRegRef}
                                />
                                {errorBreederNameEnUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.breeder", "Breeder") + " (AR)"}
                                    name={"breederNameArUnReg"}
                                    type={"text"}
                                    required={true}
                                    value={formModel.breederNameArUnReg}
                                    onChange={handleFormChange}
                                    disabled={handelDisabledButton()}
                                    ref={breederNameArUnRegRef}
                                />
                                {errorBreederNameArUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.regno", "Reg.No")}
                                    name={"regoNoUnReg"}
                                    type={"text"}
                                    onChange={handleFormChange}
                                    value={formModel.regoNoUnReg}
                                    required={true}
                                    disabled={handelDisabledButton()}
                                    ref={regoNoUnRegRef}
                                />
                                {errorRegoNoUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <label>
                                    {translate("web.color", "Color")}
                                    <i className="colorred"> *</i>
                                </label>
                                <Select
                                    options={[
                                        {
                                            label: translate("web.color", "Color"),
                                            value: null,
                                        },
                                        ...(!!horseColorsData &&
                                            horseColorsData.map((a) => ({
                                                label: a.nameEn,
                                                value: a.id,
                                            }))),
                                    ]}
                                    value={formModel.colorUnRegDrop}
                                    onChange={(e) => handleFormChange(e, "colorUnReg")}
                                    placeholder={translate("web.color", "Color")}
                                    name={"colorUnReg"}
                                    isSearchable
                                    noOptionsMessage={() =>
                                        translate("web.noOptions", "No Options")
                                    }
                                    key={"colorUnReg"}
                                    isDisabled={handelDisabledButton()}
                                    ref={colorUnRegRef}
                                />
                                {errorColorUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <label>
                                    {translate("web.origin", "Origin")}
                                    <i className="colorred"> *</i>
                                </label>
                                <Select
                                    options={[
                                        {
                                            label: translate("web.chooseOrigin", "Choose Origin"),
                                            value: null,
                                        },
                                        ...(!!countriesData &&
                                            countriesData.map((a) => ({
                                                label: a.text,
                                                value: a.value,
                                            }))),
                                    ]}
                                    value={formModel.originUnRegDrop}
                                    onChange={(e) => handleFormChange(e, "originUnReg")}
                                    placeholder={translate("web.chooseOrigin", "Choose Origin")}
                                    name={"originUnReg"}
                                    isSearchable
                                    noOptionsMessage={() =>
                                        translate("web.noOptions", "No Options")
                                    }
                                    key={"originUnReg"}
                                    isDisabled={handelDisabledButton()}
                                    ref={originUnRegRef}
                                />
                                {errorOriginUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <label>
                                    {translate("web.horseCountry", "Horse Country")}
                                    <i className="colorred"> *</i>
                                </label>
                                <Select
                                    options={[
                                        {
                                            label: translate("web.horseCountry", "Horse Country"),
                                            value: null,
                                        },
                                        ...(!!countriesData &&
                                            countriesData.map((a) => ({
                                                label: a.text,
                                                value: a.value,
                                            }))),
                                    ]}
                                    value={formModel.horseCountryUnRegDrop}
                                    onChange={(e) => handleFormChange(e, "horseCountryUnReg")}
                                    placeholder={translate("web.horseCountry", "Horse Country")}
                                    name={"horseCountryUnReg"}
                                    isSearchable
                                    noOptionsMessage={() =>
                                        translate("web.noOptions", "No Options")
                                    }
                                    key={"horseCountryUnReg"}
                                    isDisabled={handelDisabledButton()}
                                    ref={horseCountryUnRegRef}
                                />
                                {errorHorseCountryUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    htmlTags={
                                        formModel.birthDateUnReg ?
                                            <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                                {
                                                    dayjs(formModel.birthDateUnReg).format("DD/MM/YYYY")
                                                }
                                            </p> :
                                            <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                                DD/MM/YYYY
                                            </p>
                                    }
                                    name={"birthDateUnReg"}
                                    type={"normalDateService"}
                                    label={translate("web.birthDate", "Birth Date")}
                                    onChange={(e) => handleFormChange(e, "birthDateUnReg")}
                                    value={formModel.birthDateUnReg}
                                    required={true}
                                    maxDate={dayjs().format("YYYY-MM-DD")}
                                    disabled={handelDisabledButton()}
                                    ref={birthDateUnRegRef}
                                />
                                {errorBirthDateUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <NetaqInput

                                    name={"microshipUnReg"}
                                    type={"text"}
                                    label={translate("web.microchipNo", "Microchip No")}
                                    onChange={handleFormChange}
                                    value={formModel?.microshipUnReg}
                                    required={true}
                                    disabled={handelDisabledButton()}
                                    ref={microChipUnRegRef}
                                />
                                {microChipUnReg && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                            <div className={eformInput}>
                                <label>
                                    {translate("web.horsePassport", "Horse  Passport")}
                                    <i className="colorred"> *</i>
                                </label>
                                <div>
                                    <SimpleFileUpload
                                        isMulti={false}
                                        initialFiles={
                                            !!formModel?.horsePassportFile &&
                                                !!formModel.horsePassportFile &&
                                                horsePassportAttachmentFile.length === 0
                                                ? [
                                                    {
                                                        file: formModel?.horsePassportFile?.fileUrl,
                                                        name: formModel?.horsePassportFile?.fileName,
                                                    },
                                                ]
                                                : horsePassportAttachmentFile
                                        }
                                        isServer={
                                            !!formModel?.horsePassportFile &&
                                                !!formModel?.horsePassportFile &&
                                                horsePassportAttachmentFile.length === 0
                                                ? true
                                                : false
                                        }
                                        onChange={handleUploadHorsePassportChange}
                                        accept={"image/*,application/pdf"}
                                        disabled={handelDisabledButton()}
                                        ref={horsePassportRef}
                                    />
                                    {errorHorsePassport && (
                                        <span style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {/* collect semen section */}
                    {!!formModel.sex && formModel.sex.toLowerCase() === "Stallion".toLowerCase() && !!formModel.birthDate && !isLessThanUndefinedYearOld(new Date(formModel.birthDate), 2) && formModel.isOwnerTransfer &&
                        <>
                            <div className={eformInput}>
                                <label className="capatalize_text">
                                    {
                                        translate("web.doYouCollectSemenFromThisStallion", "Do You Collect Semen From This Stallion ?")
                                    }
                                </label>
                                <div className="row mx-0">
                                    <div className={'col-6'}>
                                        <NetaqInput
                                            name={"isCollectSemen"}
                                            type={"radioServiceRequest"}
                                            value={"No"}
                                            label={`${translate("web.no", "NO")}`}
                                            onChange={(e) => handleFormChange(e, "isCollectSemen")}
                                            checked={
                                                formModel.isCollectSemen === "No"
                                            }
                                            disabled={action === "view"}
                                        />
                                    </div>
                                    <div className={'col-6'}>
                                        <NetaqInput
                                            name={"isCollectSemen"}
                                            type={"radioServiceRequest"}
                                            value={"Yes"}
                                            label={`${translate("web.yes", "YES")}`}
                                            onChange={(e) => handleFormChange(e, "isCollectSemen")}
                                            checked={
                                                formModel.isCollectSemen === "Yes"
                                            }
                                            disabled={action === "view"}
                                        />
                                    </div>
                                </div>
                            </div>
                            {formModel.isCollectSemen === "Yes" &&
                                <div className={eformInput}>
                                    <NetaqInput
                                        name={"numberOfDoses"}
                                        key={"numberOfDoses"}
                                        type={"number"}
                                        value={formModel.numberOfDoses}
                                        minValue={1}
                                        label={translate("web.numberOfDoses", "Number Of Doses")}
                                        onChange={handleFormChange}
                                        disabled={action === "view"}
                                        ref={numberOfSemenDosesRef}
                                    />
                                    {errorNumberOfSemenDoses && (
                                        <span style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </span>
                                    )}
                                </div>
                            }
                        </>
                    }
                </EahsForm>

                {formModel.sex === "Mare" && (
                    <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.coveringCertificateDetails", "Covering Certificate Details")}>
                        <label>
                            {translate("web.isSheFoal", "Is She Foal")}
                        </label>
                        <div className="row mx-0">
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    name={"isSheFoal"}
                                    type={"radioServiceRequest"}
                                    value={true}
                                    ref={isSheFoaledRef}
                                    label={`${translate("web.yes", "Yes")}-`}
                                    onChange={(e) => { handleFormChange(e, "isSheFoal"); }}
                                    checked={formModel?.isSheFoal == true}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    name={"isSheFoal"}
                                    type={"radioServiceRequest"}
                                    value={false}
                                    label={`${translate("web.no", "No")}-`}
                                    onChange={(e) => { handleFormChange(e, "isSheFoal"); }}
                                    checked={formModel.isSheFoal == false}
                                    disabled={handelDisabledButton()}
                                />
                            </div>
                            {errorIsSheFoaled && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        {formModel.isSheFoal && (
                            <>
                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web.coveringCertificateNo", "Covering Certificate No")}
                                        name={"covCerNo"}
                                        type={"text"}
                                        value={formModel.covCerNo}
                                        disabled={true}
                                        ref={coveringCertificateNoRef}
                                    />
                                    {errorCoveringCertificateNo && (
                                        <p style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </p>
                                    )}
                                </div>

                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web._stallion", "Stallion")}
                                        name={"stallion"}
                                        type={"text"}
                                        value={formModel.stallion}
                                        disabled={true}
                                    />
                                </div>

                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web.coveringDate", "Covering Date")}
                                        name={"coveringDate"}
                                        type={"text"}
                                        value={formModel.coveringDate}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 rtl">
                                    <Link
                                        target="_blank"
                                        to={
                                            `/requestCoveringCertificate?serviceId=25341E00-BC23-49D7-99BD-61C9F976E73A`
                                        }
                                        className="red text-start"
                                    >
                                        {translate(
                                            "web.noValidCovCer",
                                            "No Valid Covering Certificate"
                                        )}

                                    </Link>
                                </div>

                            </>
                        )}
                    </EahsForm>
                )}

                {formModel.horseType === "UnRegistered" && (
                    <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.ownerDetails", "Owner Details")}>
                        <div className="row">
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    type={"checkbox"}
                                    label={translate(
                                        "web.exportForOtherOwner",
                                        "Export For Other Owner"
                                    )}
                                    name="otherOwnerExport"
                                    checked={formModel.otherOwnerExport}
                                    onChange={(e) => handleFormChange(e, "otherOwnerExport")}
                                    disabled={action === "view"}
                                />
                            </div>
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.ownerName", "Owner Name")}
                                name={"ownerNameExport"}
                                type={"text"}
                                onChange={handleFormChange}
                                value={formModel.ownerNameExport}
                                required={formModel.otherOwnerExport}
                                disabled={handelDisabledOwnerInputs() || (formModel.otherOwnerExport !== true)}
                                ref={ownerNameRef}
                            />
                            {errorOwnerName && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.email", "Email")}
                                name={"emailExport"}
                                type={"text"}
                                onChange={handleFormChange}
                                value={formModel.emailExport}
                                required={formModel.otherOwnerExport}
                                disabled={handelDisabledOwnerInputs() || (formModel.otherOwnerExport !== true)}
                                ref={emailRefExport}
                            />
                            {errorEmailExport && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        {formModel.otherOwnerExport && (
                            <>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'phone'}
                                        value={formModel.mobile}
                                        label={translate("web.smsPhoneNo", "Mobile No")}
                                        name={'mobile'}
                                        placeholder={'971xxxxxxxxx'}
                                        required={true}
                                        onChange={(e) => handleFormChange(e, "mobile")}
                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                        disabled={handelDisabledButton()}
                                        ref={mobileRef}
                                    />
                                    {!isPhoneNumberValid && (
                                        <div className='text-danger'>
                                            {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                        </div>
                                    )}
                                    {errorMobile && (
                                        <p style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </p>
                                    )}
                                </div>

                                <div className={eformInput}>
                                    <NetaqInput
                                        type={'phone'}
                                        value={formModel.agentMobile}
                                        label={translate("web.agentMobile", "Agent Mobile")}
                                        name={'agentMobile'}
                                        placeholder={'971xxxxxxxxx'}
                                        required={true}
                                        onChange={(e) => handleFormChange(e, "agentMobile")}
                                        setIsPhoneNumberValid={setIsAgentPhoneNumberValid}
                                        disabled={handelDisabledButton()}
                                        ref={agentMobileRef}
                                    />
                                    {!isAgentPhoneNumberValid && (
                                        <div className='text-danger'>
                                            {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                        </div>
                                    )}
                                    {errorAgentMobile && (
                                        <p style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </p>
                                    )}
                                </div>

                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web.passport", "Passport")}
                                        name={"passportNo"}
                                        type={"text"}
                                        disabled={handelDisabledButton()}
                                        value={formModel.passportNo}
                                        onChange={handleFormChange}
                                        isDash={true}
                                        required={true}
                                        ref={passportNoRef}
                                    />
                                    {errorPassportNo && (
                                        <span style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </span>
                                    )}
                                </div>

                                <div className={eformInput}>
                                    <label>
                                        {translate("web.ownerPassportCopy", "Owner Passport Copy")}
                                        <i className="colorred"> *</i>
                                    </label>
                                    <div>
                                        <SimpleFileUpload
                                            isMulti={false}
                                            initialFiles={residencePermitAttachmentFile}
                                            isServer={
                                                residencePermitAttachmentFile?.length > 0 &&
                                                typeof residencePermitAttachmentFile[0]?.file === "string" &&
                                                residencePermitAttachmentFile[0]?.file?.startsWith('http')
                                            }
                                            onChange={handleUploadResidencePermitChange}
                                            accept={"image/*,application/pdf"}
                                            disabled={handelDisabledButton()}
                                            ref={residencePermitRef}
                                        />
                                        {errorResidencePermit && (
                                            <span style={{ color: "red" }}>
                                                {translate("web.requiredField", "Required Field")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </EahsForm>
                )}

                {/* {!formModel.isOwnerTransfer && (formModel.exportType === "PERMANENT" || formModel.exportType === "TEMPORARY") && (
                    <HorseLeasingSection
                        formModel={formModel}
                        handleFormChange={handleFormChange}
                        handelDisabledButton={handelDisabledButton}
                        leasingContractAttachmentFile={leasingContractAttachmentFile}
                        handleUploadLeasingContractChange={handleUploadLeasingContractChange}
                        leasingContractRef={leasingContractRef}
                        errorLeasingContract={errorLeasingContract}
                        errorLeaseStartDate={errorLeaseStartDate}
                        errorLeaseEndDate={errorLeaseEndDate}
                        leaseStartDateRef={leaseStartDateRef}
                        leaseEndDateRef={leaseEndDateRef}
                        leasePermissionsRef={leasePermissionsRef}
                        errorLeasePermissions={errorLeasePermissions}
                    />
                )} */}

                {(formModel.isOwnerTransfer || formModel.isLeasing) && (
                    <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(
                        formModel.isLeasing ? "web.lesseeDetailsReceivingCountry" : (formModel.isOwnerTransfer ? "web.buyerDetailsReceivingCountry" : "web.addressReceivingCountry"),
                        formModel.isLeasing ? "Lessee Details in Receiving Country" : (formModel.isOwnerTransfer ? "Buyer Details in Receiving Country" : "Address in Receiving Country")
                    )}>
                        {(formModel.isOwnerTransfer || formModel.isLeasing) && (
                            <>
                                <div className="col-md-12 col-sm-12 rtl p0 px-3">
                                    <NetaqInput
                                        type={"checkbox"}
                                        label={translate(
                                            formModel.isLeasing ? "web.exportForNonRegisteredLessee" : "web.exportForNonRegisteredOwner",
                                            formModel.isLeasing ? "Export For Non Registered Lessee" : "Export For Non Registered Owner"
                                        )}
                                        name="otherOwner"
                                        checked={formModel.otherOwner}
                                        onChange={(e) => handleFormChange(e, "otherOwner")}
                                        // disabled={handelDisabledOwnerInputs()}
                                        disabled={action === "view"}
                                    />
                                </div>

                                {!formModel.otherOwner && (
                                    <div className={eformInput}>
                                        <label>
                                            {translate(formModel.isLeasing ? "web.lessee" : "web.buyer", formModel.isLeasing ? "Lessee" : "Buyer")}
                                            <i className="colorred">*</i>
                                        </label>
                                        <AsyncSelect
                                            isClearable
                                            loadOptions={promiseBuyerOptions}
                                            defaultOptions={false}
                                            onInputChange={(newValue) => setInputBuyerValue(newValue)}
                                            inputValue={inputBuyerValue}
                                            value={formModel.buyerDrop}
                                            loadingMessage={() => translate("web.loading", "Loading")}
                                            onChange={(e) => handleFormChange(e, "buyer")}
                                            placeholder={
                                                translate("web.typeToSearch", "Type To Search") + "..."
                                            }
                                            noOptionsMessage={() =>
                                                translate("web.noOptions", "No Options")
                                            }
                                            isDisabled={action === "view"}
                                            ref={buyerRef}
                                        />
                                        {errorBuyer && (
                                            <span style={{ color: "red" }}>
                                                {translate("web.requiredField", "Required Field")}
                                            </span>
                                        )}
                                    </div>
                                )}

                                {formModel.otherOwner && (
                                    <div className={eformInput}>
                                        <NetaqInput
                                            label={translate(formModel.isLeasing ? "web.lesseeName" : "web.buyerName", formModel.isLeasing ? "Lessee Name" : "Buyer Name")}
                                            name={"buyerName"}
                                            type={"horseName"}
                                            isSupportAllCharacters={true}
                                            onChange={handleFormChange}
                                            value={formModel.buyerName}
                                            required={formModel.otherOwner}
                                            // disabled={handelDisabledOwnerInputs()}
                                            disabled={action === "view"}
                                            ref={buyerNameRef}
                                        />
                                        {errorBuyerName && (
                                            <p style={{ color: "red" }}>
                                                {translate("web.requiredField", "Required Field")}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </>
                        )}

                        {(!formModel.isOwnerTransfer || (formModel.isOwnerTransfer && formModel.otherOwner)) && (
                            <>
                                {/* <div className={eformInput}>
                            <NetaqInput
                                type={"select"}
                                label={translate("web.country", "Country")}
                                placeholder={translate("web.chooseCountry", "Choose country")}
                                name={"receivingCountry"}
                                listSelect={nationalityOptions}
                                value={formModel?.receivingCountryDrop}
                                onChange={(e) => handleFormChange(e, "receivingCountry")}
                                // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                disabled={(formModel.isOwnerTransfer && !formModel.otherOwner) || action === "view"}
                                required={true}
                                ref={receivingCountryRef}
                            />
                            {errorReceivingCountry && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div> */}

                                {/* <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.address", "Address")}
                                name={"receivingArea"}
                                type={"text"}
                                // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                disabled={(formModel.isOwnerTransfer && !formModel.otherOwner) || action === "view"}
                                value={formModel.receivingArea}
                                onChange={handleFormChange}
                                required={true}
                                ref={receivingAreaRef}
                            />
                            {errorReceivingArea && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div> */}
                            </>
                        )}

                        {formModel.otherOwner ? <div className={eformInput}>
                            <NetaqInput
                                type={'phone'}
                                value={formModel.phone}
                                label={translate("web.smsPhoneNo", "Mobile No")}
                                name={'phone'}
                                placeholder={'971xxxxxxxxx'}
                                required={true}
                                onChange={(e) => handleFormChange(e, "phone")}
                                setIsPhoneNumberValid={setIsPhoneNumberValid}
                                // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                disabled={(formModel.isOwnerTransfer && !formModel.otherOwner) || action === "view"}
                                ref={phoneRef}
                            />
                            {!isPhoneNumberValid &&
                                <div className='text-danger'>
                                    {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                </div>
                            }
                            {errorPhone && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>
                            :
                            <div className={eformInput}>
                                <NetaqInput
                                    type={'text'}
                                    value={formModel.phone}
                                    label={translate("web.smsPhoneNo", "Mobile No")}
                                    name={'phone'}
                                    placeholder={'971xxxxxxxxx'}
                                    required={true}
                                />
                            </div>}

                        {(formModel.isOwnerTransfer || formModel.isLeasing) && (
                            <div className={eformInput}>
                                <NetaqInput
                                    // label={translate((formModel.otherOwner ? "web.passportOrEmiratesId" : "web.passport"), (formModel.otherOwner ? "PassportNo - EmiratesId" : "Passport"))}
                                    label={translate("web.passport", "Passport")}
                                    name={"idNumber"}
                                    type={"text"}
                                    // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                    disabled={((formModel.isOwnerTransfer || formModel.isLeasing) && !formModel.otherOwner) || action === "view"}
                                    value={formModel.idNumber}
                                    onChange={handleFormChange}
                                    isDash={true}
                                    required={true}
                                    ref={idNumberRef}
                                />
                                {errorIdNumber && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                        )}

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.email", "Email")}
                                name={"email"}
                                type={"text"}
                                required={true}
                                // disabled={handelDisabledOwnerInputs() || (formModel.isOwnerTransfer && !formModel.otherOwner)}
                                disabled={((formModel.isOwnerTransfer || formModel.isLeasing) && !formModel.otherOwner) || action === "view"}
                                onChange={handleFormChange}
                                value={formModel.email}
                                ref={emailRef}
                            />
                            {errorEmail && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div>

                        {(formModel.isOwnerTransfer || formModel.isLeasing) && formModel.otherOwner && (
                            <div className={eformInput}>
                                <label>
                                    {translate(formModel.isLeasing ? "web.lesseePassportCopy" : "web.ownerPassportCopy", formModel.isLeasing ? "Lessee Passport Copy" : "Owner Passport Copy")}
                                    <i className="colorred"> *</i>
                                </label>
                                <div>
                                    <SimpleFileUpload
                                        isMulti={false}
                                        initialFiles={
                                            !!formModel.filePathOwnerPassport &&
                                                !!formModel.fileUrlOwnerPassport &&
                                                ownerPassportAttachmentFile.length === 0
                                                ? [
                                                    {
                                                        file: formModel?.filePathOwnerPassport,
                                                        name: formModel?.fileNameOwnerPassport,
                                                    },
                                                ]
                                                : ownerPassportAttachmentFile
                                        }
                                        isServer={
                                            !!formModel.filePathOwnerPassport &&
                                                !!formModel.fileUrlOwnerPassport &&
                                                ownerPassportAttachmentFile.length === 0
                                                ? true
                                                : false
                                        }
                                        onChange={handleUploadOwnerPassportChange}
                                        accept={"image/*,application/pdf"}
                                        disabled={handelDisabledButton()}
                                        ref={ownerPassportRef}
                                    />
                                    {errorOwnerPassport && (
                                        <span style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </EahsForm>
                )}

                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.shippingAgent", "Shipping Agent")}>
                    <div className={eformInput}>
                        <label>
                            {translate("web.shippingAgent", "Shipping Agent")}
                            <i className="colorred"> *</i>
                        </label>
                        <Select
                            options={[
                                {
                                    label: translate("web.shippingAgent", "Shipping Agent"),
                                    value: null,
                                },
                                ...(!!getShippingAgentsData &&
                                    getShippingAgentsData.map((a) => ({
                                        label: a.text,
                                        value: a.value,
                                    }))),
                            ]}
                            value={formModel.shippingAgentDrop}
                            onChange={(e) => handleFormChange(e, "shippingAgent")}
                            placeholder={translate("web.shippingAgent", "Shipping Agent")}
                            name={"shippingAgent"}
                            isSearchable
                            noOptionsMessage={() =>
                                translate("web.noOptions", "No Options")
                            }
                            autoFocus={true}
                            key={"shippingAgent"}
                            isDisabled={handelDisabledButton()}
                            ref={shippingAgentRef}
                        />
                        {errorShippingAgent && (
                            <span style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </span>
                        )}
                    </div>
                </EahsForm>

                {/* Comments */}
                {(!!formModel.comment || !!formModel.ownerComment) && (
                    <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
                        {!!formModel.comment && (
                            // eahs Comment
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.eahsComments", "EAHS Comments")}
                                    name={"adminComment"}
                                    type={"textarea"}
                                    maxchars={1150}
                                    value={formModel.comment}
                                    disabled={true}
                                />
                            </div>
                        )}

                        {(!!formModel.ownerComment || (formModel.eventName === "SentBack" && action !== "view")) && (
                            // owner Comment
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.ownerComment", "Owner Comment")}
                                    name={"ownerComment"}
                                    type={"textarea"}
                                    maxchars={1150}
                                    value={formModel.ownerComment}
                                    onChange={handleFormChange}
                                    disabled={formModel.eventName !== "SentBack" ? true : false}
                                />
                            </div>
                        )}

                        {formModel.isApproveHorseAction && action === "view" && (
                            // HorseOwner Comment
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.rejectReason", "Reject Reason")}
                                    name={"HorseOwnerComment"}
                                    type={"textarea"}
                                    maxchars={1150}
                                    value={formModel.HorseOwnerComment}
                                    onChange={handleFormChange}
                                    required={true}
                                />
                                {errorHorseOwnerComment && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                        )}
                    </EahsForm>
                )}

                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
                    {formModel.exportType === "TEMPORARY" && (
                        <div className={eformTerms}>
                            <NetaqInput
                                type={"checkbox"}
                                label={translate(
                                    "web.exportTerm1",
                                    "Export Term 1"
                                )}
                                name="term1"
                                checked={formModel.term1 || action != null}
                                onChange={(e) => handleFormChange(e, "term1")}
                                disabled={formModel.eventName === "" ? false : true}
                            />
                        </div>
                    )}

                    {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
                        return (
                            <div className={eformTerms} key={index}>
                                <NetaqInput
                                    type={"checkbox"}
                                    label={item}
                                    name={`option${index + 1}`}
                                    checked={checkedItems[`option${index + 1}`] || action != null}
                                    onChange={handleCheckboxChange}
                                    disabled={formModel.eventName !== ""}
                                />
                            </div>
                        );
                    })}
                </EahsForm>

                {/* buttons*/}
                <div className={eFormButtonsContainer}>
                    {(formModel.eventName === "" || formModel.eventName === "Draft") && (
                        <DraftBtn
                            key={'draft'}
                            onClick={() => handelFormSubmit("Draft", "", 'Draft')}
                            disabled={
                                formModel.eventName === "" ||
                                    formModel.eventName === "Draft"
                                    ? false
                                    : true
                            }
                        />
                    )}

                    {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                        <ApproveAndPayLaterBtn
                            selectedAccountId={profile?.value}
                            isApprove={false}
                            key={`paylater`}
                            onClick={() =>
                                handelFormSubmit("Draft", "no", 'Pay')
                            }
                            disabled={
                                formModel.eventName === "SentBack"
                                    ? true
                                    : false
                            }
                        />
                    )}

                    {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                        <ApproveAndPayBtn
                            selectedAccountId={profile?.value}
                            isApprove
                            key={translate("web.approvePay", "Approve And Pay")}
                            onClick={() =>
                                handelFormSubmit("Draft", "yes", 'Pay')
                            }
                            disabled={
                                formModel.eventName === "SentBack"
                                    ? true
                                    : false
                            }
                        />
                    )}

                    {(getServiceDefinitionByIdData.serviceFees === 0 || (formModel.eventName === "SentBack" && action !== "view")) && (
                        <SubmitServiceBtn
                            key={translate("web.submit", "Submit")}
                            onClick={() =>
                                handelFormSubmit("Submit", "", "Submit")
                            }
                            disabled={
                                getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                                    ? false
                                    : true
                            }
                        />
                    )}

                    {formModel.isApproveHorseAction && action === "view" && (
                        <>
                            <div className={eformFormButton}>
                                <button type="button" className="btn btn-outline-success mx-2" onClick={() => handleApproveReject("Approve")}>
                                    {translate("web.approve", "Approve")}
                                </button>
                                <button type="button" className="btn btn-outline-danger mx-2" onClick={() => handleApproveReject("Reject")}>
                                    {translate("web.reject", "Reject")}
                                </button>
                            </div>
                        </>
                    )}
                </div>

            </div>
        </>
    );
}
